import html2pdf from "html2pdf.js";
import logo from "../assets/DesarrollandoTerritorios.png"

// Funciones auxiliares para obtener descripciones de los códigos.
const getProgramaDescriptions = (programaCodes) => {
  if (!programaCodes) return ""

  // Define the programa options (copy from ContractForm.jsx)
const opcionesProgramas = [
  { value: "", label: "Seleccionar..." },
  {
    value: "1.1.1",
    label:
      "1.1.1 Fortalecimiento de los servicios de salud hacia la descentralizacion, la ampliacion de la cobertura. ",
  },
  { value: "1.1.2", label: "1.1.2 Vida Saludable en Copacabana. " },
  { value: "1.1.3", label: "1.1.3 Infraestructura innovadora y con calidad. " },
  { value: "1.1.4", label: "1.1.4  Fortalecimiento de los niveles de gobernanza de la salud.  " },
  { value: "1.2.1", label: "1.2.1 Fortalecimiento integral, pedagógico y educativo. " },
  { value: "1.2.2", label: "1.2.2 Acceso y permanencia en sistema educativo desde un enfoque territorial. " },
  {
    value: "1.2.3",
    label:
      "1.2.3 Desarrollo de un ecosistema  educativo 4.0 que apunte al fortalecimiento y encadenamineto de los diferentes niveles educativos. ",
  },
  { value: "1.3.1", label: "1.3.1 La cultura como vocación para el desarrollo en Copacabana. " },
  { value: "1.3.2", label: "1.3.2 Gestión, protección y salvaguardia del patrimonio cultural. " },
  { value: "1.3.3", label: "1.3.3 Mejoramiento y dotación de la infraestructura cultural.  " },
  { value: "1.3.4", label: "1.3.4 Gobernaza para la inclusión cultural. " },
  {
    value: "1.4.1",
    label:
      "1.4.1 Fortalecimiento de la cultura deportiva para el fomento a la recreación, la actividad física y el deporte. ",
  },
  {
    value: "1.4.2",
    label:
      "1.4.2 Fortalecimiento de la práctica deportiva, la infraestructura, la formación y preparación de deportistas aficionados y de alto rendimiento. ",
  },
  { value: "1.4.3", label: "1.4.3 Liderazgo en gobernanza para la gestión deportiva. " },
  {
    value: "2.1.1",
    label:
      "2.1.1 Protección, conservación y restauración de los sistemas naturales a través del SILAP y sus servicios ecosistemicos. ",
  },
  { value: "2.1.2", label: "2.1.2 Gestión Sostenible del Agua. " },
  { value: "2.1.3", label: "2.1.3 Adaptación al cambio climático. " },
  { value: "2.1.4", label: "2.1.4 Educación y cultura ambiental territorializada. " },
  { value: "2.1.5", label: "2.1.5 Gestión de residuos y fortalecimiento ambiental. " },
  { value: "2.1.6", label: "2.1.6 Producción verde y responsable. " },
  { value: "2.2.1", label: "2.2.1 Bienestar animal y tenencia responsable. " },
  { value: "2.3.1", label: "2.3.1 Hacia un gestión del riesgo integral. " },
  { value: "2.3.2", label: "2.3.2 Planificación e implementación técnica y normativa para el control del riesgo. " },
  {
    value: "2.3.3",
    label:
      "2.3.3 Capacidades técnicas y tecnológica para las medidas de prevención y mitigación de la gestión del riesgo. ",
  },
  { value: "2.4.1", label: "2.4.1 Vivienda digna para sus habitantes y servicios públicos. " },
  {
    value: "2.5.1",
    label: "2.5.1 Fortalecimiento de la Movilidad en Copacabana sostenible y con enfoque diferencial. ",
  },
  { value: "2.5.2", label: "2.5.2 Mejora de la Infraestructura Vial. " },
  { value: "2.5.3", label: "2.5.3 Movilidad innovadora e  inteligente. " },
  { value: "2.6.1", label: "2.6.1 Actualización del Plan Básico de Ordenamineto Territorial. " },
  { value: "2.6.2", label: "2.6.2 Ordenamiento territorial, infraestructura y desarrollo urbano. " },
  { value: "3.1.1", label: "3.1.1 Hacia una cultura del emprendimiento y el desarrollo empresarial. " },
  {
    value: "3.1.2",
    label: "3.1.2 Emprendimiento como alternativa para la generación y formalización para  empleo. ",
  },
  { value: "3.1.3", label: "3.1.3 Fortalecimiento empresarial desde un enfoque de  valor agregado. " },
  {
    value: "3.1.4",
    label: "3.1.4 Fortalecimiento del ecosistema empresarial y de innovación con enfoque metropolitano. ",
  },
  { value: "3.1.5", label: "3.1.5 Promoción del empleo y el trabajo. " },
  { value: "3.2.1", label: "3.2.1 Desarrollo agropecuario sostenible. " },
  { value: "3.2.2", label: "3.2.2 Desarrollo de cadenas de valor y promoción de productos locales. " },
  { value: "3.3.1", label: "3.3.1 Actualización del Plan de Desarrollo Turístico sostenible. " },
  {
    value: "3.3.2",
    label:
      "3.3.2 Gestión integral del ecosistema turistico y el fortalecimiento de la promoción y el mercadeo, para el mejoramiento de la competitividad turística. ",
  },
  { value: "3.3.3", label: "3.3.3 Fortalecimiento de la Infraestructura Turística. " },
  {
    value: "3.4.1",
    label:
      "3.4.1 Desarrollo empresarial de base tecnológica y su integración al distrito de CTeI Regional Metropolitano. ",
  },
  {
    value: "3.4.2",
    label: "3.4.2 Fortalecimiento de las capacidades digitales y la adopción de nuevas tecnologías 4.0. ",
  },
  { value: "3.4.3", label: "3.4.3 Fortalecimiento de la Infraestructura Tecnológica para la competitividad. " },
  { value: "3.4.4", label: "3.4.4 Hacia un territorio inteligente. " },
  { value: "4.1.1", label: "4.1.1 Desarrollo integral de la primera infancia. " },
  {
    value: "4.1.2",
    label: "4.1.2 Fortalecimiento de la infraestructura para el desarrollo integral de la primera infancia. ",
  },
  { value: "4.10.1", label: "4.10.1 Fortalecimiento integral de las víctimas del conflicto. " },
  {
    value: "4.11.1",
    label:
      "4.11.1 Programa integral de seguridad  e instrumentos de planificación y gestión como el plan de seguridad. ",
  },
  {
    value: "4.11.2",
    label:
      "4.11.2 Reconstrucción del Tejido Social a través del Arte y el Deporte para la convivencia en copacabana. ",
  },
  {
    value: "4.11.3",
    label: "4.11.3 Implementar soluciones comunitarias y tecnológicas para la prevención del delito. ",
  },
  {
    value: "4.2.1",
    label: "4.2.1 Desarrollo integral, las capacidades especiales y los talentos excepcionales de la niñez. ",
  },
  { value: "4.3.1", label: "4.3.1 Fortalecimiento y protección integral del adulto mayor. " },
  { value: "4.4.1", label: "4.4.1 Fortalecimiento integral de la juventud. " },
  { value: "4.5.1", label: "4.5.1 Desarrollo integral de las mujeres. " },
  { value: "4.6.1", label: "4.6.1 Fortalecimiento  integral de de la población LGTIQA+. " },
  { value: "4.7.1", label: "4.7.1 Fortalecimiento  integral de de la población en condición de discapacidad. " },
  { value: "4.8.1", label: "4.8.1 Fortalecimiento y atención   integral de de la población habitante de calle. " },
  { value: "4.9.1", label: "4.9.1 Inclusión del sector religioso y fortalecimiento del culto religioso. " },
  {
    value: "5.1.1",
    label:
      "5.1.1 Fortalecimiento de la hacienda publica municpal y la  gestión de recursos para el municipio de copacabana. ",
  },
  {
    value: "5.1.2",
    label:
      "5.1.2 Modernización institucional y de instrumentos técnicos y tecnológicos para mejorar la prestación de los servicios de manera cercana para los ciudadanos de copacabana. ",
  },
  {
    value: "5.2.1",
    label:
      "5.2.1 Fortalecimiento de la participación y la gestión pública para el desarrollo de procesos de articulación y transparencia en torno a la legitimidad y confianza comunitaria en la administración de Copacabana. ",
  },
  {
    value: "5.3.1",
    label:
      "5.3.1 Fortalecimiento integral del bienestar del personal articulada a la gestión pública en copacabana. ",
  },
]

const formatDateForPDF = (dateValue) => {
  if (!dateValue) return "";
  
  let dateStr = String(dateValue).trim();
  
  // Si ya viene en formato YYYY-MM-DD (del input date)
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`; // ✅ Conversión directa SIN crear Date
  }
  
  // Si viene como ISO con hora (2026-01-07T00:00:00.000Z)
  const isoMatch = dateStr.match(/^(\d{4})-(\d{2})-(\d{2})T/);
  if (isoMatch) {
    const [, year, month, day] = isoMatch;
    return `${day}/${month}/${year}`; // ✅ Conversión directa SIN crear Date
  }
  
  // Fallback: intentar parsear como Date
  try {
    const d = new Date(dateValue);
    if (isNaN(d.getTime())) return "";
    
    // ✅ Usar getUTCDate() para evitar timezone shift
    const year = d.getUTCFullYear();
    const month = String(d.getUTCMonth() + 1).padStart(2, "0");
    const day = String(d.getUTCDate()).padStart(2, "0");
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error("Error formateando fecha:", error);
    return "";
  }
};

  // Manejar tanto entradas de tipo arreglo como de tipo cadena.
  let codesArray = []

  if (Array.isArray(programaCodes)) {
    codesArray = programaCodes
  } else if (typeof programaCodes === "string") {
    codesArray = programaCodes.split(",")
  } else {
    return ""
  }

  // Asignar a cada código su descripción.
  const descriptions = codesArray.map((code) => {
    const option = opcionesProgramas.find((opt) => opt.value === code.trim())
    return option ? option.label : code
  })

  // Unir las descripciones con saltos de línea
  return descriptions.join("<br>")
}

const getIndicadorDescriptions = (indicadorCodes) => {
  if (!indicadorCodes) return ""

  // Define the indicador options (copy from ContractForm.jsx)
 const opcionesIndicadores = [
  { value: "", label: "Seleccionar..." },
  {
    value: "1.1.1.1",
    label:
      '1.1.1.1 Campañas de Salud en Zonas descentralizadas, en el marco de "Salud en mi barrio y mi vereda", realizadas. ',
  },
  {
    value: "1.1.1.2",
    label:
      "1.1.1.2 Cobertura de servicios de primer nivel de complejidad para la Población No Asegurada - PNA que demanda la atención. ",
  },
  { value: "1.1.1.3", label: "1.1.1.3 Cobertura del aseguramiento en salud del Régimen Subsidiado. " },
  {
    value: "1.1.1.4",
    label:
      "1.1.1.4 Acciones para impactar la cobertura en salud de los habitantes, realizando depuración de base de datos, encuestas Sisbén, afiliaciones al régimen subsidiado, afiliaciones a través del SAT, afiliaciones institucionales, seguimiento a recién nacidos y gestión PNA. ",
  },
  {
    value: "1.1.2.1",
    label:
      "1.1.2.1 Acciones como jornadas para la prevención, rutas de intervención, acompañamiento familiar y campañas de divulgación y formación en temas de consumo de sustancias psicoactivas implementadas. ",
  },
  { value: "1.1.2.2", label: "1.1.2.2 Víctimas de violencias sexuales identificadas, con atención integral. " },
  { value: "1.1.2.3", label: "1.1.2.3 Campañas en temas de salud sexual y reproductiva implementadas. " },
  {
    value: "1.1.2.4",
    label:
      "1.1.2.4 Difusiones de la situación de salud realizadas en las comunidades organizadas, mediante boletines epidemiológicos que serán compartidos por las redes sociales de la alcaldía municipal. ",
  },
  {
    value: "1.1.2.5",
    label:
      "1.1.2.5 Acciones de educación a través de campañas educativas, capacitaciones y acompañamientos para la salud oral realizadas. ",
  },
  { value: "1.1.2.6", label: "1.1.2.6 Visitas a establecimientos de interés sanitario realizadas. " },
  {
    value: "1.1.2.7",
    label:
      "1.1.2.7 Cumplimiento del Plan de Intervenciones Colectivas bajo la estrategia Atención Primaria en Salud. ",
  },
  {
    value: "1.1.2.8",
    label:
      "1.1.2.8 Campañas de detección temprana, de educación en salud y orientación para la promoción y prevención de condiciones crónicas prevalentes realizadas. ",
  },
  {
    value: "1.1.2.9",
    label:
      "1.1.2.9 Campañas para abordar situaciones de salud relacionadas con condiciones ambientales implementadas. ",
  },
  { value: "1.1.2.10", label: "1.1.2.10 Vacunas contra la rabia para perros y gatos aplicadas en el municipio. " },
  {
    value: "1.1.2.11",
    label: "1.1.2.11 Personas beneficiadas en las acciones para la prevención y atención de alteraciones visuales. ",
  },
  {
    value: "1.1.2.12",
    label: "1.1.2.12 Campañas para abordar situaciones prevalentes de origen laboral implementadas. ",
  },
  {
    value: "1.1.2.13",
    label:
      "1.1.2.13 Sesiones grupales de apoyo psicosocial para el trámite de experiencias asociadas con la conducta suicida realizados. ",
  },
  {
    value: "1.1.2.14",
    label:
      "1.1.2.14 Sesiones de capacitación sobre el reconocimiento de las habilidades para la vida dirigida a la comunidad en general realizadas. ",
  },
  {
    value: "1.1.2.15",
    label:
      "1.1.2.15 Acciones de salud pública como campañas, jornadas de concientización y capacitaciones  realizadas para el autocuidado y la promoción de hábitos de vida saludable con la comunidad en general. ",
  },
  { value: "1.1.2.16", label: "1.1.2.16 Encuentros y capacitaciones sobre salud mental realizados. " },
  {
    value: "1.1.2.17",
    label: "1.1.2.17 Índice de Riesgo de la Calidad del Agua - IRCA para consumo humano – municipal. ",
  },
  {
    value: "1.1.2.18",
    label: "1.1.2.18 Acciones en salud mental y hábitos de vida sanos dirigidas a los grupos de adulto mayor. ",
  },
  {
    value: "1.1.2.19",
    label:
      "1.1.2.19 Acciones como capacitaciones, acompañamientos a grupos poblacionales, divulgación y promoción en medios de comunicación, entre otros, en salud mental y hábitos de vida sanos dirigidas a las instituciones educativas. ",
  },
  {
    value: "1.1.2.20",
    label: "1.1.2.20 Personas beneficiadas con la estrategia Te escuchamos: Copacabana como un entorno protector. ",
  },
  {
    value: "1.1.3.1",
    label:
      "1.1.3.1 Transferencia para el fortalecimiento de la Red Pública de servicios de salud de la ESE Hospital Santa Margarita de Copacabana realizada por la Secretaría de Salud. ",
  },
  { value: "1.1.4.1", label: "1.1.4.1 Ejecución de los recursos del Fondo Local de Salud. " },
  {
    value: "1.1.4.2",
    label:
      "1.1.4.2 Satisfacción de los usuarios que acceden a los servicios de salud en la red prestadora del municipio. ",
  },
  {
    value: "1.1.4.3",
    label: "1.1.4.3 PQRSD relacionadas a Inspección, Vigilancia y Control Sanitario (IVC) atendidas. ",
  },
  { value: "1.1.4.4", label: "1.1.4.4 Cumplimiento en la capacidad de gestión en salud. " },
  {
    value: "1.1.4.5",
    label: "1.1.4.5 Cumplimiento del Plan de Acción de la Política Pública de Participación Social en Salud. ",
  },
  {
    value: "1.2.1.1",
    label:
      "1.2.1.1 Espacios para Aprender: Infraestructura educativa mejorada para la Innovación y Calidad Educativa. ",
  },
  {
    value: "1.2.1.2",
    label: "1.2.1.2 Sedes Educativas dotadas con mobiliario para un entorno de aprendizaje adecuado y funcional. ",
  },
  { value: "1.2.1.3", label: "1.2.1.3 Estrategia de tránsito armónico actualizada e implementada. " },
  {
    value: "1.2.1.4",
    label:
      "1.2.1.4 Estudiantes en proceso de transición, beneficiados con la estrategia de tránsito armónico en primera infancia. ",
  },
  {
    value: "1.2.1.5",
    label: "1.2.1.5 Personas beneficiadas con la estrategia Educación sin barreras: Unidad de Atención Integral. ",
  },
  {
    value: "1.2.1.6",
    label:
      "1.2.1.6 Estrategia 'Educación sin barreras' para la atención integral de estudiantes en situación de discapacidad, creada e implementada. ",
  },
  {
    value: "1.2.1.7",
    label: "1.2.1.7 Número de estudiantes beneficiados con el Programa de Alimentación Escolar (PAE) implementado. ",
  },
  {
    value: "1.2.1.8",
    label:
      "1.2.1.8 Estrategia formulada e implementada del Consultorio Educativo para el fortalecimiento académico de estudiantes de las EE. ",
  },
  { value: "1.2.1.9", label: "1.2.1.9 Estudiantes beneficiados por la estrategia del Consultorio Educativo. " },
  {
    value: "1.2.1.10",
    label:
      "1.2.1.10 Estudiantes beneficiados con tiquetes urbanos y rurales entregados para los estudiantes del municipio. ",
  },
  { value: "1.2.2.1", label: "1.2.2.1 Formulación, aprobación y socialización del Plan Educativo Municipal. " },
  {
    value: "1.2.2.2",
    label: "1.2.2.2 Foros de educación como escenarios de participación, diálogo y reflexión implementados. ",
  },
  { value: "1.2.2.3", label: "1.2.2.3 Estrategias de Bilingüismo implementadas. " },
  { value: "1.2.2.4", label: "1.2.2.4 Personas beneficiadas con estrategias de promoción del bilingüismo. " },
  { value: "1.2.2.5", label: "1.2.2.5 Cátedra municipal de Historia Local creada e implementada. " },
  { value: "1.2.2.6", label: "1.2.2.6 Sedes educativas con la cátedra municipal de Historia Local Implementada. " },
  {
    value: "1.2.2.7",
    label: "1.2.2.7 Programa de estímulos para la permanencia y calidad educativa creado y ejecutado. ",
  },
  {
    value: "1.2.2.8",
    label:
      "1.2.2.8 Jornadas de estímulos en el marco del programa de estímulos para la permanencia y calidad educativa. ",
  },
  {
    value: "1.2.2.9",
    label:
      "1.2.2.9 Docentes de las instituciones educativas oficiales capacitados en ámbitos técnicos, tecnológicos y de actualización académica/metodológica. ",
  },
  {
    value: "1.2.2.10",
    label:
      "1.2.2.10 Estrategia de reconocimiento y fortalecimiento de prácticas educativas innovadoras creado e implementado. ",
  },
  {
    value: "1.2.2.11",
    label:
      "1.2.2.11 Estrategia de bienestar para la comunidad educativa creada e implementada (físico, emocional y social). ",
  },
  {
    value: "1.2.2.12",
    label:
      "1.2.2.12 Docentes de las instituciones educativas oficiales beneficiados por la estrategia de bienestar docente. ",
  },
  {
    value: "1.2.2.13",
    label:
      "1.2.2.13 Establecimientos educativos articulados a los programas y estrategias de la administración municipal. ",
  },
  {
    value: "1.2.2.14",
    label:
      "1.2.2.14 Programas y estrategias de la administración en el marco de la articulación con las instituciones educativas. ",
  },
  {
    value: "1.2.2.15",
    label: "1.2.2.15 Procesos de articulación entre primera infancia y el sector educativo oficial implementados. ",
  },
  {
    value: "1.2.2.16",
    label:
      "1.2.2.16 Personas impactadas en los procesos de articulación entre primera infancia y el sector educativo oficial. ",
  },
  {
    value: "1.2.2.17",
    label:
      "1.2.2.17 Personas beneficiadas con estrategias de educación para el acceso a la educación técnica, tecnológica y profesional. ",
  },
  { value: "1.2.2.18", label: "1.2.2.18 Fondo de educación superior creado. " },
  { value: "1.2.2.19", label: "1.2.2.19 Puntaje promedio en Pruebas Saber. " },
  {
    value: "1.2.2.20",
    label:
      "1.2.2.20 Estudiantes de último grado de establecimientos públicos beneficiados con programas de preuniversitario y preicfes como fortalecimiento al acceso de la educación superior. ",
  },
  {
    value: "1.2.2.21",
    label:
      "1.2.2.21 Beneficiarios de estrategias o programas de fomento para el acceso a la educación superior o terciaria. ",
  },
  {
    value: "1.2.2.22",
    label:
      "1.2.2.22 Programa de Orientación Vocacional, intereses y motivaciones para el proyecto de vida de los estudiantes de las instituciones educativas oficiales, creado e implementado. ",
  },
  {
    value: "1.2.2.23",
    label:
      "1.2.2.23 Estudiantes de media académica beneficiados con el programa de orientación vocacional, intereses y motivaciones para el proyecto de vida. ",
  },
  {
    value: "1.2.3.1",
    label:
      "1.2.3.1 Acciones como capacitaciones, asesorías a instituciones educativas oficiales, integración a PEI, acompañamientos a docentes, directivos docentes y estudiantes para el fortalecimiento del Ecosistema educativo 4.0. ",
  },
  { value: "1.2.3.2", label: "1.2.3.2 Estrategia del Ecosistema Educativo 4.0 creada e implementada. " },
  {
    value: "1.2.3.3",
    label:
      "1.2.3.3 Programa STEAM: habilidades en ciencia, tecnología, educación, arte y matemáticas, creado e implementado. ",
  },
  { value: "1.2.3.4", label: "1.2.3.4 Estudiantes beneficiados por el programa STEAM Copacabana. " },
  { value: "1.2.3.5", label: "1.2.3.5 Estrategia Educación con vos creada e implementada. " },
  { value: "1.2.3.6", label: "1.2.3.6 Personas beneficiadas con la estrategia: Educación con Vos. " },
  { value: "1.2.3.7", label: "1.2.3.7 Estrategia de 'Cero anafabetismo' actualizada e implementada. " },
  { value: "1.2.3.8", label: "1.2.3.8 Personas beneficiadas con la estrategia de alfabetización. " },
  { value: "1.2.3.9", label: "1.2.3.9 Estrategia 'El Alcalde en Tu Colegio' creada e implementada. " },
  {
    value: "1.2.3.10",
    label:
      "1.2.3.10 Visitas a las instituciones educativas desde la estrategia 'El Alcalde en Tu Colegio' realizadas. ",
  },
  {
    value: "1.3.1.1",
    label: "1.3.1.1 Plan de estímulos, becas y reconocimientos para los artistas locales implementado. ",
  },
  { value: "1.3.1.2", label: "1.3.1.2 Capacitaciones técnicas sobre normativas y proyectos anualmente. " },
  { value: "1.3.1.3", label: "1.3.1.3 Estrategia del nodo de economía cultural y creativa gestionado. " },
  {
    value: "1.3.1.4",
    label: "1.3.1.4 Estrategia InnovArte para Impulso a la Economía Creativa de Copacabana implementada. ",
  },
  { value: "1.3.1.5", label: "1.3.1.5 Sistema de circulación artístico y cultural implementado. " },
  {
    value: "1.3.1.6",
    label: "1.3.1.6 Programa de desarrollo de habilidades artísticas para la profesionalización. ",
  },
  {
    value: "1.3.2.1",
    label:
      "1.3.2.1 Acciones de divulgación e intervención para gestión, protección y salvaguardia del patrimonio cultural realizadas. ",
  },
  {
    value: "1.3.2.2",
    label:
      "1.3.2.2 Estrategia 'Copacabana es mi pueblo', como estrategia de preservación, conservación y divulgación del patrimonio cultural, implementada. ",
  },
  { value: "1.3.2.3", label: "1.3.2.3 Escuela de vigías del patrimonio cultural creada. " },
  { value: "1.3.2.4", label: "1.3.2.4 Inventario del Patrimonio material e inmaterial realizado. " },
  { value: "1.3.2.5", label: "1.3.2.5 Planes de manejo Arqueológico realizados. " },
  { value: "1.3.2.6", label: "1.3.2.6 Planes Especiales de Manejo y Protección implementados. " },
  { value: "1.3.2.7", label: "1.3.2.7 Plan Especial de Salvaguardia implementado. " },
  {
    value: "1.3.2.8",
    label:
      "1.3.2.8 Estrategia de recuperación e integración de caminos ancestrales, en alianza entre la secretaría de medio ambiente y agricultura con la secretaría de educación y cultura, implementada. ",
  },
  { value: "1.3.3.1", label: "1.3.3.1 Espacios descentralizados para la cultura dotados. " },
  { value: "1.3.3.2", label: "1.3.3.2 Espacios de divulgación e integración cultural fortalecidos y creados. " },
  { value: "1.3.3.3", label: "1.3.3.3 Red municipal de bibliotecas en barrios y veredas creada y fortalecida. " },
  { value: "1.3.3.4", label: "1.3.3.4 Nuevas colecciones adquiridas para la red municipal de bibliotecas. " },
  { value: "1.3.3.5", label: "1.3.3.5 Espacios con Sentido: infraestructura cultural mejorada. " },
  { value: "1.3.3.6", label: "1.3.3.6 Espacios con Sentido: infraestructura cultural construida. " },
  {
    value: "1.3.4.1",
    label:
      "1.3.4.1 Programas de formación y educación cultural, inclusivos, en la Casa de la Cultura implementados. ",
  },
  {
    value: "1.3.4.2",
    label:
      "1.3.4.2 Programas del sector cultural del municipio orientados al acceso y la participación activa de la comunidad fortalecidos. ",
  },
  { value: "1.3.4.3", label: "1.3.4.3 Población en procesos artísticos y culturales formadas anualmente. " },
  {
    value: "1.3.4.4",
    label:
      "1.3.4.4 Plan decenal de Cultura como una herramienta estratégica para la articulación y orientación de las políticas culturales elaborado. ",
  },
  { value: "1.3.4.5", label: "1.3.4.5 Zonas del municipio participantes de la red municipal de bibliotecas. " },
  { value: "1.3.4.6", label: "1.3.4.6 Personas que participan de la red municipal de bibliotecas. " },
  { value: "1.3.4.7", label: "1.3.4.7 Consejo Municipal de Cultura fortalecido. " },
  { value: "1.3.4.8", label: "1.3.4.8 Alianzas para la gestión cultural realizadas. " },
  {
    value: "1.3.4.9",
    label: "1.3.4.9 Intervenciones para apoyar y fortalecer los espacios de participación ciudadana. ",
  },
  { value: "1.3.4.10", label: "1.3.4.10 Sistema municipal de información artística y cultural fortalecido. " },
  { value: "1.3.4.11", label: "1.3.4.11 Festivales y ferias artísticas y culturales realizadas. " },
  {
    value: "1.4.1.1",
    label: "1.4.1.1 Personas que acceden a servicios deportivos, recreativos y de actividad física. ",
  },
  { value: "1.4.1.2", label: "1.4.1.2 Deportes, incluyendo alternativos o no convencionales, ofertados. " },
  { value: "1.4.1.3", label: "1.4.1.3 Niños, niñas, adolescentes y jóvenes inscritos en Escuelas Deportivas. " },
  { value: "1.4.1.4", label: "1.4.1.4 Niños, niñas, adolescentes y jóvenes con talento deportivo incentivados. " },
  {
    value: "1.4.1.5",
    label:
      "1.4.1.5 Jornadas deportivas institucionales de juegos escolares, intercolegiados, departamentales y nacionales. ",
  },
  {
    value: "1.4.1.6",
    label:
      "1.4.1.6 Número de deportistas participantes en juegos escolares, intercolegiados, departamentales y nacionales. ",
  },
  {
    value: "1.4.1.7",
    label:
      "1.4.1.7 Creación de la estrategia “Noches comunitarias” como espacios de descentralización, diversión y esparcimiento para los habitantes. ",
  },
  { value: "1.4.1.8", label: "1.4.1.8 Zonas participantes de las “Noches comunitarias. ”" },
  { value: "1.4.1.9", label: "1.4.1.9 Eventos deportivos interbarriales e interveredales realizados y/o apoyados. " },
  {
    value: "1.4.1.10",
    label:
      "1.4.1.10 Torneos y festivales deportivos y recreativos realizados y/o apoyados de manera descentralizada. ",
  },
  {
    value: "1.4.1.11",
    label:
      "1.4.1.11 Eventos deportivos interinstitucionales con proyección externa al municipio realizados y/o apoyados. ",
  },
  {
    value: "1.4.2.1",
    label: "1.4.2.1 Capacitaciones a los formadores, entrenadores y expertos deportivos brindadas. ",
  },
  {
    value: "1.4.2.2",
    label: "1.4.2.2 Equipo interdisciplinar para el acompañamiento y asesoramiento a deportistas creado. ",
  },
  {
    value: "1.4.2.3",
    label:
      "1.4.2.3 Fondo económico para apoyo a deportistas que representen al municipio en competencias externas creado. ",
  },
  { value: "1.4.2.4", label: "1.4.2.4 Infraestructura deportiva mantenida y mejorada. " },
  { value: "1.4.2.5", label: "1.4.2.5 Infraestructura deportiva construida. " },
  { value: "1.4.3.1", label: "1.4.3.1 Plan Integral de Educación Física y Deporte creado e implementado. " },
  {
    value: "1.4.3.2",
    label: "1.4.3.2 Sedes Educativas con implementación del Plan Integral de Educación Física y Deporte. ",
  },
  { value: "1.4.3.3", label: "1.4.3.3 Establecimiento del INDER Copacabana. " },
  {
    value: "1.4.3.4",
    label:
      "1.4.3.4 Dotación deportiva entregada para brindar condiciones adecuadas en la realización de la actividad deportiva. ",
  },
  { value: "1.4.3.5", label: "1.4.3.5 Alianzas con diferentes actores realizadas para la gestión deportiva. " },
  { value: "2.1.1.1", label: "2.1.1.1 SILAP formulado con gestión para su implementación. " },
  { value: "2.1.1.2", label: "2.1.1.2 Generación de Espacios Públicos Verdes Urbanos. " },
  {
    value: "2.1.1.3",
    label: "2.1.1.3 Estrategia de reforestación y restauración de áreas de importancia ambiental en el municipio. ",
  },
  { value: "2.1.1.4", label: "2.1.1.4 Área total para la protección y conservación de ecosistemas naturales. " },
  { value: "2.1.2.1", label: "2.1.2.1 Áreas con PSA. " },
  { value: "2.1.2.2", label: "2.1.2.2 Intervenciones en acueductos veredales para su mejora y fortalecimiento. " },
  {
    value: "2.1.2.3",
    label:
      "2.1.2.3 Acciones integrales con capacitaciones, sensibilizaciones, acompañamientos y monitoreos para Protección y Gestión Sostenible del Agua implementadas. ",
  },
  { value: "2.1.2.4", label: "2.1.2.4 Análisis hidrológico de cuencas con enfoque regenerativo. " },
  {
    value: "2.1.2.5",
    label:
      "2.1.2.5 Intervenciones mediante descontaminación en el Sistema de alcantarillado, pozos sépticos y control de descargas directas para su fortalecimiento. ",
  },
  {
    value: "2.1.3.1",
    label:
      "2.1.3.1 Acciones de planificación, gestión, control y monitoreo ambiental en Copacabana implementadas para enfrentar los fenómenos del cambio climático. ",
  },
  { value: "2.1.3.2", label: "2.1.3.2 Diseño de ruta estratégica para adaptación al cambio climático. " },
  {
    value: "2.1.3.3",
    label:
      "2.1.3.3 Diseño e implementación del plan de ahorro y eficiencia energética para la administración pública, y la promoción de energías renovables. ",
  },
  {
    value: "2.1.3.4",
    label:
      "2.1.3.4 Acciones enfocadas en la implementación de medidas de adaptación y resiliencia de la infraestructura. ",
  },
  {
    value: "2.1.4.1",
    label:
      "2.1.4.1 Campañas de capacitación y sensibilización en cambio climático, adaptación y gestión del riesgo. ",
  },
  {
    value: "2.1.4.2",
    label:
      "2.1.4.2 Campañas de capacitación y sensibilización en manejo integral de residuos sólidos y sostenibilidad. ",
  },
  {
    value: "2.1.4.3",
    label:
      "2.1.4.3 Estrategia para el mejoramiento y construcción de espacios para la formación e investigación ambiental. ",
  },
  {
    value: "2.1.4.4",
    label: "2.1.4.4 Acciones enfocadas en impulsar la educación ambiental y la transformación cultural. ",
  },
  { value: "2.1.5.1", label: "2.1.5.1 Plan de Gestión Integral de Residuos actualizado. " },
  {
    value: "2.1.5.2",
    label:
      "2.1.5.2 Acciones implementadas para la formalización de recuperadores y el fortalecimiento de empresas de reciclaje. ",
  },
  { value: "2.1.6.1", label: "2.1.6.1 Acciones con enfoque en economía circular. " },
  { value: "2.1.6.2", label: "2.1.6.2 Acciones enfocadas en acompañamiento, control y vigilancia ambiental. " },
  { value: "2.1.6.3", label: "2.1.6.3 Programa participativo de Sello Ambiental. " },
  {
    value: "2.2.1.1",
    label:
      "2.2.1.1 Política pública de bienestar animal para la protección y promoción del bienestar de los animales diseñada. ",
  },
  { value: "2.2.1.2", label: "2.2.1.2 Creación de Infraestructura y Unidades de Atención y Bienestar Animal. " },
  {
    value: "2.2.1.3",
    label:
      "2.2.1.3 Cátedra de Bienestar animal implementada en las instituciones educativas oficiales del municipio. ",
  },
  {
    value: "2.2.1.4",
    label: "2.2.1.4 Atención integral a animales en condición de vulnerabilidad reportados y/o identificados. ",
  },
  {
    value: "2.2.1.5",
    label: "2.2.1.5 Campañas de salud, bienestar, adopción y sensibilización para Mascotas realizadas. ",
  },
  { value: "2.3.1.1", label: "2.3.1.1 Plan de Gestión del Riesgo Institucional actualizado. " },
  {
    value: "2.3.1.2",
    label:
      "2.3.1.2 Acciones de control y seguimiento necesario a las especies invasoras del municipio, con mapeo de zonas, seguimiento a tendencias, divulgación a la comunidad,  realizadas. ",
  },
  {
    value: "2.3.1.3",
    label:
      "2.3.1.3 Acciones Correctivas y Preventivas, a través de medios comunicacionales, visitas a sitios, capacitaciones y formaciones, realizadas en torno a la gestión integral del riesgo de desastres. ",
  },
  {
    value: "2.3.2.1",
    label:
      "2.3.2.1 Estrategia de Verificación Cumplimiento Normativo y Supervisión de Construcciones diseñada e implementada. ",
  },
  { value: "2.3.3.1", label: "2.3.3.1 Sistemas de Monitoreo y Alerta Temprana implementados. " },
  { value: "2.3.3.2", label: "2.3.3.2 Nueva Sede de Bomberos actualizada y con condiciones adecuadas. " },
  { value: "2.3.3.3", label: "2.3.3.3 Dotación de organismos de socorro y salvaguardia gestionados. " },
  { value: "2.4.1.1", label: "2.4.1.1 Copacabana con Vivienda Digna: Mejoramiento de viviendas realizados. " },
  {
    value: "2.4.1.2",
    label: "2.4.1.2 Copacabana con Vivienda Digna: construcciones de vivienda nueva viabilizadas. ",
  },
  {
    value: "2.4.1.3",
    label:
      "2.4.1.3 Personas beneficiadas con asesoría integral para acceder a beneficios económicos para proyectos de vivienda de interés social (VIS), vivienda de interés prioritario (VIP) y mejoramiento de vivienda. ",
  },
  { value: "2.4.1.4", label: "2.4.1.4 Iniciativas de saneamiento y titulación de bienes fiscales ejecutadas. " },
  {
    value: "2.5.1.1",
    label:
      "2.5.1.1 Acciones de fortalecimiento de la Movilidad en Copacabana, como campañas de sensibilización, asesorías, capacitaciones y acompañamientos, de manera sostenible y con enfoque diferencial implementadas. ",
  },
  {
    value: "2.5.1.2",
    label: "2.5.1.2 Plan integral para el mejoramiento de la movilidad en el municipio de Copacabana diseñado. ",
  },
  { value: "2.5.1.3", label: "2.5.1.3 Parque automotor Público mejorado. " },
  {
    value: "2.5.2.1",
    label: "2.5.2.1 Intervenciones para lograr la mejora y/o ampliación de la infraestructura vial. ",
  },
  { value: "2.5.2.2", label: "2.5.2.2 Mantenimiento de la infraestructura vial. " },
  {
    value: "2.5.3.1",
    label: "2.5.3.1 Estrategia 'Copacabana, hacia una movilidad innovadora e  inteligente' implementada. ",
  },
  { value: "2.5.3.2", label: "2.5.3.2 Acciones de Educación y Cultura Vial implementadas. " },
  { value: "2.6.1.1", label: "2.6.1.1 Plan Básico de Ordenamiento Territorial de Copacabana actualizado. " },
  { value: "2.6.2.1", label: "2.6.2.1 Infraestructura municipal de Copacabana mejorada o mantenida. " },
  { value: "2.6.2.2", label: "2.6.2.2 Sistema de alumbrado público municipal mejorado y ampliado. " },
  {
    value: "2.6.2.3",
    label:
      "2.6.2.3 Estrategia de integración de espacios públicos seguros, estimulantes y adecuados para niños y niñas diseñada y ejecutada. ",
  },
  { value: "2.6.2.4", label: "2.6.2.4 Espacio público de Copacabana mejorado. " },
  { value: "2.6.2.5", label: "2.6.2.5 Gestionar el aumento de cobertura de la red de gas en la zona veredal. " },
  { value: "3.1.1.1", label: "3.1.1.1 Emprendimientos fortalecidos y promovidos. " },
  { value: "3.1.1.2", label: "3.1.1.2 Estrategias de integración y financiación empresarial implementadas. " },
  {
    value: "3.1.1.3",
    label: "3.1.1.3 Capacitaciones realizadas a emprendimientos para la creación y consolidación de empresa. ",
  },
  { value: "3.1.1.4", label: "3.1.1.4 Eventos para el fomento del emprendimiento realizados. " },
  {
    value: "3.1.2.1",
    label:
      "3.1.2.1 Campañas para la estimulación de la creación, formalización y mejoramiento de emprendimientos realizadas. ",
  },
  { value: "3.1.2.2", label: "3.1.2.2 Estrategia 'Emprendimiento para el Futuro' implementada. " },
  {
    value: "3.1.2.3",
    label:
      "3.1.2.3 Acciones de formación para generación de competencias y habilidades (empleos de futuro e industria Tech) realizadas. ",
  },
  { value: "3.1.2.4", label: "3.1.2.4 Convenios público/privados para el fortalecimiento del empleo realizados. " },
  {
    value: "3.1.3.1",
    label: "3.1.3.1 Empresas entorno a la estrategia de 'Semaforización empresarial' clasificadas. ",
  },
  {
    value: "3.1.3.2",
    label: "3.1.3.2 Estrategia de semaforización empresarial para la sostenibilidad implementada. ",
  },
  {
    value: "3.1.3.3",
    label: "3.1.3.3 Incentivos tributarios para empresas que se asienten en el municipio generados. ",
  },
  { value: "3.1.3.4", label: "3.1.3.4 Estrategia 'El alcalde visita tu empresa' implementada. " },
  { value: "3.1.4.1", label: "3.1.4.1 Redes empresariales diseñadas e implementadas. " },
  { value: "3.1.4.2", label: "3.1.4.2 Capacitaciones, asesorías y alianzas con la mesa empresarial realizadas. " },
  {
    value: "3.1.4.3",
    label:
      "3.1.4.3 Red de Negocios Copacabana e integración regional con el distrito de Ciencia, Tecnología e Innovación de Medellín diseñada e implementada. ",
  },
  {
    value: "3.1.5.1",
    label: "3.1.5.1 Acciones de fortalecimiento de la oficina de empleo en Copacabana implementadas. ",
  },
  {
    value: "3.1.5.2",
    label: "3.1.5.2 Acciones para la promoción de empleo de la mano de la oficina pública de empleo implementadas. ",
  },
  { value: "3.2.1.1", label: "3.2.1.1 Plan Agropecuario Municipal (PAM) formulado e implementado. " },
  {
    value: "3.2.1.2",
    label:
      "3.2.1.2 Acciones de fortalecimiento para la producción y comercialización del sector agropecuario, como capacitaciones, acompañamiento, asesorías, entre otras, realizadas. ",
  },
  { value: "3.2.1.3", label: "3.2.1.3 Estrategia de 'eco huertas comunitarias' implementada. " },
  {
    value: "3.2.1.4",
    label:
      "3.2.1.4 Acciones de formación para el desarrollo de capacidades e iniciativas para esquemas asociativos en el sector agropecuario. ",
  },
  { value: "3.2.2.1", label: "3.2.2.1 Estrategia 'Mercado Campesino Sostenible' implementada. " },
  { value: "3.2.2.2", label: "3.2.2.2 Acciones para el desarrollo de cadenas de valor y comercialización. " },
  {
    value: "3.2.2.3",
    label:
      "3.2.2.3 Acciones para que la Plaza de mercado sea un espacio óptimo para la comercialización y el impulso de las cooperativas y/o asociaciones agrícolas y pecuarias mejorada. ",
  },
  { value: "3.3.1.1", label: "3.3.1.1 Política pública de turismo con enfoque sostenible diseñada y expedida. " },
  { value: "3.3.2.1", label: "3.3.2.1 Ecosistema Empresarial Turístico implementado. " },
  {
    value: "3.3.2.2",
    label:
      "3.3.2.2 Acciones de capacitación, acompañamientos, asesorías, divulgación, promoción para implementar el Turismo Comunitario y Cultural en el territorio. ",
  },
  { value: "3.3.2.3", label: "3.3.2.3 Acciones de Endomarketing turístico implementadas. " },
  {
    value: "3.3.2.4",
    label: "3.3.2.4 Asesorías y capacitaciones a los prestadores de servicios turísticos en el municipio. ",
  },
  { value: "3.3.2.5", label: "3.3.2.5 Marca Turística de Copacabana creada. " },
  {
    value: "3.3.2.6",
    label: "3.3.2.6 Estrategia para la promoción de la Marca Municipio de Copacabana implementada. ",
  },
  { value: "3.3.3.1", label: "3.3.3.1 Infraestructura turística mejorada. " },
  {
    value: "3.3.3.2",
    label:
      "3.3.3.2 Estudios de capacidad de carga en los puntos turísticos prioritarios del municipio de Copacabana realizados. ",
  },
  { value: "3.3.3.3", label: "3.3.3.3 Sistema de información turística implementado. " },
  { value: "3.4.1.1", label: "3.4.1.1 Oficina de cooperación internacional, innovación y desarrollo creada. " },
  {
    value: "3.4.1.2",
    label: "3.4.1.2 Reemplazo de fuentes de suministro de energía eléctrica para edificaciones públicas. ",
  },
  {
    value: "3.4.2.1",
    label:
      "3.4.2.1 Acciones de formación en capacidades digitales y la adopción de nuevas tecnologías 4.0 realizadas. ",
  },
  {
    value: "3.4.3.1",
    label:
      "3.4.3.1 Acciones ligadas a la cualificación, actualización digital y dotación tecnológica para la gestión de mejora de la infraestructura tecnológica realizadas. ",
  },
  { value: "3.4.4.1", label: "3.4.4.1 Estrategia Copacabana ciudad inteligente diseñada. " },
  {
    value: "3.4.4.2",
    label:
      "3.4.4.2 Acciones para el acceso y uso de las Tecnologías de la Información y las Comunicaciones implementadas en el marco de Ciudad Inteligente. ",
  },
  {
    value: "4.1.1.1",
    label:
      "4.1.1.1 Estrategia para desarrollo integral de la primera infancia implementada: acceso a los servicios básicos, acompañamiento psicosocial y protección de derechos. ",
  },
  { value: "4.1.1.2", label: "4.1.1.2 Estrategia para la atención integral a madres gestantes implementadas. " },
  {
    value: "4.1.1.3",
    label: "4.1.1.3 Plan Municipal de Prevención Integral de abuso sexual infantil implementada. ",
  },
  {
    value: "4.1.1.4",
    label:
      "4.1.1.4 Acciones de seguimiento, control y mejoras para la seguridad nutricional y alimentaria implementadas. ",
  },
  { value: "4.1.1.5", label: "4.1.1.5 Estrategia de entornos protectores y seguros implementada. " },
  { value: "4.1.2.1", label: "4.1.2.1 Infraestructura mejorada. " },
  {
    value: "4.2.1.1",
    label: "4.2.1.1 Estrategia para el desarrollo integral de la niñez y adolescencia implementada. ",
  },
  {
    value: "4.3.1.1",
    label:
      "4.3.1.1 Adultos mayores beneficiados con acciones de bienestar, fortalecimiento y protección integral implementadas. ",
  },
  {
    value: "4.3.1.2",
    label:
      "4.3.1.2 Política pública de envejecimiento humano y vejez, que incluya los programas de 'Resignificación y protección del adulto mayor' para entornos adecuados y 'Dignidad en la veje' que incluya actividades lúdicas, recreativas, culturales y deportivas actualizada. ",
  },
  { value: "4.3.1.3", label: "4.3.1.3 Acciones de promoción del subsidio de adulto mayor realizadas. " },
  {
    value: "4.3.1.4",
    label: "4.3.1.4 Viabilización de la Construcción y dotación del Centro del Adulto Mayor gestionado. ",
  },
  {
    value: "4.3.1.5",
    label:
      "4.3.1.5 Estrategia de estímulos, incentivos y reconocimientos a los adultos mayores reconociendo su labor y papel en la comunidad realizada. ",
  },
  { value: "4.3.1.6", label: "4.3.1.6 Festival recreativo, cultural, deportivo del adulto mayor realizado. " },
  { value: "4.4.1.1", label: "4.4.1.1 Política pública de juventud actualizada. " },
  { value: "4.4.1.2", label: "4.4.1.2 Estrategia 'STEAM Zone' para formación especializada en STEAM implementada. " },
  {
    value: "4.4.1.3",
    label:
      "4.4.1.3 Programa de acompañamiento integral a jóvenes (emocional, social, económico) creado e implementado. ",
  },
  {
    value: "4.4.1.4",
    label:
      "4.4.1.4 Acciones de seguimiento, formación, acompañamiento y asesoramiento dirigidas al fortalecimiento del Consejo municipal de Juventud y de la plataforma municipal de juventud desarrolladas. ",
  },
  {
    value: "4.4.1.5",
    label:
      "4.4.1.5 Capacitaciones y asesorías a personeros estudiantiles para fortalecer sus labores de líderes y gestores ante el municipio realizadas. ",
  },
  { value: "4.4.1.6", label: "4.4.1.6 Casa de la juventud planeada y creada. " },
  {
    value: "4.4.1.7",
    label:
      "4.4.1.7 Acciones de formación y/o capacitación juvenil para el fortalecimiento de los jóvenes emprendedores del municipio desarrolladas. ",
  },
  {
    value: "4.4.1.8",
    label:
      "4.4.1.8 Convenios público-privados para generar programas de acompañamiento y fortalecimiento de actividades no convencionales y educación no formal para los jóvenes, en el marco del programa 'Más Oportunidades para Nuestros Jóvenes'  realizados. ",
  },
  { value: "4.4.1.9", label: "4.4.1.9 Estrategia 'jóvenes talento' implementada. " },
  {
    value: "4.5.1.1",
    label:
      "4.5.1.1 Acciones de acompañamiento, formación y creación de alianzas para empoderamiento y autonomía femenina implementadas. ",
  },
  { value: "4.5.1.2", label: "4.5.1.2 Estrategia integral 'Mujeres Seguras y Libres de Violencia' implementada. " },
  {
    value: "4.5.1.3",
    label: "4.5.1.3 'La casa morada': un lugar de encuentro para las mujeres y con atención priorizada creada. ",
  },
  {
    value: "4.5.1.4",
    label:
      "4.5.1.4 Programa integral de protección de víctimas de la violencia, líderes sociales y madres cabeza de familia. ",
  },
  { value: "4.5.1.5", label: "4.5.1.5 Red de apoyo de las madres cabeza de hogar creada e implementada. " },
  {
    value: "4.5.1.6",
    label:
      "4.5.1.6 Estrategia integral de promoción y prevención en salud especializada en enfermedades de las mujeres implementada. ",
  },
  {
    value: "4.5.1.7",
    label: "4.5.1.7 Estrategia de creación de escuela de liderazgo Mujeres Líderes y Participativas. ",
  },
  { value: "4.5.1.8", label: "4.5.1.8 Política pública de la mujer actualizada. " },
  { value: "4.5.1.9", label: "4.5.1.9 Dirección municipal de las mujeres en Copacabana creada. " },
  {
    value: "4.6.1.1",
    label:
      "4.6.1.1  Acciones de fortalecimiento integral a través de acompañamiento, asesorías, alianzas estratégicas y capacitaciones de la población LGTIQA+ implementadas. ",
  },
  { value: "4.6.1.2", label: "4.6.1.2 Política pública municipal de diversidad diseñada e implementada. " },
  {
    value: "4.6.1.3",
    label:
      "4.6.1.3 Programa 'Desde mi realidad' como estrategia de comunicación multimodal para la población LGBTIQA+ implementada. ",
  },
  { value: "4.6.1.4", label: "4.6.1.4 Mesa diversa fortalecida. " },
  {
    value: "4.6.1.5",
    label: "4.6.1.5 'Casa de Colores': Espacio de Encuentro y con atención integral para la diversidad adecuada. ",
  },
  {
    value: "4.6.1.6",
    label: "4.6.1.6 Acciones de Educación Inclusiva, laboral y Sensibilización Comunitaria implementadas. ",
  },
  { value: "4.7.1.1", label: "4.7.1.1 Centro de Atención Integral para la Discapacidad (CAID) creado. " },
  { value: "4.7.1.2", label: "4.7.1.2 Capacitaciones a los cuidadores de personas con Discapacidad realizadas. " },
  {
    value: "4.7.1.3",
    label:
      "4.7.1.3 Acciones para empresas, emprendimiento y comercios con capacitaciones, divulgación, concientización, entre otras, para Inclusión Laboral para Personas con Discapacidad implementadas. ",
  },
  { value: "4.7.1.4", label: "4.7.1.4 Plan ocupacional para personas con discapacidad diseñado. " },
  { value: "4.7.1.5", label: "4.7.1.5 Acciones para la Accesibilidad y Movilidad Urbana implementadas. " },
  {
    value: "4.7.1.6",
    label:
      "4.7.1.6 Encuentros de bienestar emocional, estimulación, creatividad y expresión para las personas con discapacidad. ",
  },
  {
    value: "4.7.1.7",
    label:
      "4.7.1.7 Acciones de Empoderamiento y Participación Comunitaria de personas con discapacidad implementadas. ",
  },
  { value: "4.8.1.1", label: "4.8.1.1 Estrategia de Atención psicosocial y resocialización implementada. " },
  {
    value: "4.8.1.2",
    label:
      "4.8.1.2 Acciones de acompañamiento, formación y campañas de divulgación para promover programas de desintoxicación implementadas. ",
  },
  { value: "4.8.1.3", label: "4.8.1.3 Política pública para personas en situación de calle diseñada y expedida. " },
  {
    value: "4.9.1.1",
    label:
      "4.9.1.1 Espacios de participación liderados por el sector religioso, para la garantía del derecho con plan de acción implementado. ",
  },
  {
    value: "4.9.1.2",
    label: "4.9.1.2 Organizaciones basadas en la fe con proyectos de cooperación social y comunitarios formulados. ",
  },
  {
    value: "4.9.1.3",
    label:
      "4.9.1.3 Acciones que promuevan un entorno protector alrededor de los lugares de culto, dentro del Plan Integral de Seguridad y Convivencia Ciudadana (PISCC). ",
  },
  {
    value: "4.9.1.4",
    label: "4.9.1.4 Capacitaciones para la promoción y protección del derecho a la libertad religiosa. ",
  },
  {
    value: "4.9.1.5",
    label: "4.9.1.5 Política pública de libertad religiosa y de cultos formulada e implementada. ",
  },
  { value: "4.10.1.1", label: "4.10.1.1 Ruta Integral de Acompañamiento a Víctimas (RIAV) actualizada. " },
  {
    value: "4.10.1.2",
    label:
      "4.10.1.2 Estrategia de articulación a los programas de apoyo y atención del gobierno nacional y departamental con las víctimas de Copacabana implementada. ",
  },
  { value: "4.10.1.3", label: "4.10.1.3 Oficina de Atención a Víctimas fortalecida. " },
  {
    value: "4.10.1.4",
    label:
      "4.10.1.4 Acciones de promoción del reconocimiento y respaldo a las iniciativas de las personas y organizaciones de víctimas en el marco del proceso de reparación integral y la búsqueda de reconciliación realizadas. ",
  },
  {
    value: "4.10.1.5",
    label:
      "4.10.1.5 Acciones de Empoderamiento y Participación de las Víctimas en la Construcción de Paz implementadas. ",
  },
  { value: "4.10.1.6", label: "4.10.1.6 Política pública de víctimas implementada. " },
  {
    value: "4.11.1.1",
    label:
      "4.11.1.1 Acciones preventivas y operativas que aporten a la seguridad integral, desde la formación ciudadana, integración de la policía cívica, divulgación y promoción de seguridad, tomas de espacios, entre otros. ",
  },
  {
    value: "4.11.1.2",
    label: "4.11.1.2 Capacitaciones a la comunidad sobre autocuidado con perspectiva de prevención del delito. ",
  },
  {
    value: "4.11.1.3",
    label: "4.11.1.3 Acciones que garanticen entornos protectores y seguros para niños, niñas y adolescentes. ",
  },
  { value: "4.11.1.4", label: "4.11.1.4 Adecuación y dotación de las comisarías de familia. " },
  { value: "4.11.1.5", label: "4.11.1.5 Capacitación y asesorías técnicas a las comisarías de familias. " },
  { value: "4.11.1.6", label: "4.11.1.6 Consejos de seguridad descentralizados realizados. " },
  {
    value: "4.11.1.7",
    label: "4.11.1.7 Convenio estratégico con el transporte público para la seguridad gestionado. ",
  },
  {
    value: "4.11.1.8",
    label:
      "4.11.1.8 Convenios estratégicos con la policía nacional de carabineros y el ejército nacional gestionados. ",
  },
  {
    value: "4.11.1.9",
    label: "4.11.1.9 Planes Integrales de Seguridad y Convivencia Ciudadana -PISCC diseñados e implementados. ",
  },
  { value: "4.11.1.10", label: "4.11.1.10 CAI Móviles viabilizados. " },
  {
    value: "4.11.1.11",
    label:
      "4.11.1.11 Desarrollo de estrategia de seguridad cercana a las comunidades a través de recorridos en el municipio. ",
  },
  { value: "4.11.1.12", label: "4.11.1.12 Estrategia de reacción inmediata con la Policía Nacional implementada. " },
  {
    value: "4.11.1.13",
    label: "4.11.1.13 Articulación con los entes territoriales de las estrategias de seguridad realizada. ",
  },
  { value: "4.11.1.14", label: "4.11.1.14 Nueva estación de policía con condiciones adecuadas viabilizada. " },
  { value: "4.11.1.15", label: "4.11.1.15 Frentes de seguridad constituidos. " },
  { value: "4.11.2.1", label: "4.11.2.1 Jornadas de educación, convivencia y seguridad realizadas. " },
  {
    value: "4.11.2.2",
    label:
      "4.11.2.2 Acciones de Reconstrucción del Tejido Social a través del Arte y el Deporte para la convivencia implementadas. ",
  },
  {
    value: "4.11.2.3",
    label:
      "4.11.2.3 Estrategia de apropiación de espacios con programas de inserción cultural para la sana convivencia. ",
  },
  { value: "4.11.2.4", label: "4.11.2.4 Talleres juveniles con gestión comunitaria de la policía. " },
  { value: "4.11.3.1", label: "4.11.3.1 Seguridad informática y protección de la información pública fortalecida. " },
  { value: "4.11.3.2", label: "4.11.3.2 Estrategia de integración tecnológica para la seguridad implementada. " },
  { value: "4.11.3.3", label: "4.11.3.3 Centro de comunicaciones, comando y control modernizado. " },
  {
    value: "5.1.1.1",
    label:
      "5.1.1.1 Estrategia de fortalecimiento de la Capacidad Analítica y Gestión de la Información Financiera realizada. ",
  },
  {
    value: "5.1.1.2",
    label:
      "5.1.1.2 Estrategia para la generación de ingresos municipales y la gestión de recursos territoriales implementada. ",
  },
  { value: "5.1.2.1", label: "5.1.2.1 Acciones de promoción y fortalecimiento de los mecanismos de denuncia. " },
  {
    value: "5.1.2.2",
    label: "5.1.2.2 Estrategia para la prevención del conflicto de interés creada e implementada. ",
  },
  { value: "5.1.2.3", label: "5.1.2.3 Código de integridad para los funcionarios fortalecido. " },
  {
    value: "5.1.2.4",
    label:
      "5.1.2.4 Estrategia para el fortalecimiento de la gestión pública del municipio de Copacabana implementada. ",
  },
  {
    value: "5.1.2.5",
    label:
      "5.1.2.5 Acciones de fortalecimiento de las organizaciones de la sociedad civil implementadas, a través, de acompañamiento, formación y divulgación. ",
  },
  { value: "5.1.2.6", label: "5.1.2.6 Oficina de atención al ciudadano fortalecida. " },
  { value: "5.2.1.1", label: "5.2.1.1 Mecanismo de participación ciudadana y comunal creado e implementado. " },
  {
    value: "5.2.1.2",
    label:
      "5.2.1.2 Programa de incentivos de las buenas prácticas, gestiones y acciones de los organismos comunales creados. ",
  },
  { value: "5.2.1.3", label: "5.2.1.3 Formaciones en Auditoría Ciudadana y Control Social realizadas. " },
  {
    value: "5.2.1.4",
    label:
      "5.2.1.4 Estrategia con las Juntas de Acción Comunal para la ejecución de obras según el marco legal que lo rija creada e implementada. ",
  },
  { value: "5.2.1.5", label: "5.2.1.5 Canales de comunicación directa con la comunidad creados y fortalecidos. " },
  {
    value: "5.2.1.6",
    label: "5.2.1.6 NPS implementado adecuadamente para el mejoramiento de la atención al ciudadano. ",
  },
  { value: "5.2.1.7", label: "5.2.1.7 Dirección de Participación Ciudadana creada. " },
  {
    value: "5.3.1.1",
    label:
      "5.3.1.1 Acciones de fortalecimiento del bienestar integral del personal articulada a la gestión pública implementadas. ",
  },
  { value: "5.3.1.2", label: "5.3.1.2 Calificaciones y capacitaciones a los empleados públicos realizadas. " },
  {
    value: "5.3.1.3",
    label: "5.3.1.3 Programa de incentivos para los empleados públicos sobresalientes creado e implementado. ",
  },
  { value: "5.3.1.4", label: "5.3.1.4 Actualización de los procesos de la administración municipal realizada. " },
  {
    value: "5.3.1.5",
    label: "5.3.1.5 Programa de inducción y reinducción de los empleados públicos fortalecido y actualizado. ",
  },
  {
    value: "5.3.1.6",
    label:
      "5.3.1.6 Creación del programa 'Somos equipo' como espacios de integración, formación y fortalecimiento del bienestar integral. ",
  },
  {
    value: "5.3.1.7",
    label: "5.3.1.7 Estrategia de modernización y articulación de la gestión pública implementada. ",
  },
  { value: "5.3.1.8", label: "5.3.1.8 Capacitaciones a funcionarios en habilidades digitales realizadas. " },
  { value: "5.3.1.9", label: "5.3.1.9 Espacios físicos de la administración municipal mejorados. " },
  {
    value: "5.3.1.10",
    label:
      "5.3.1.10 Estrategia de actualización del equipo tecnológico de la administración municipal realizada e implementada. ",
  },
  { value: "5.3.1.11", label: "5.3.1.11 Plan de comunicación implementado, adaptado y socializado. " },
  { value: "5.3.1.12", label: "5.3.1.12 Rendición de cuentas planeado y ejecutado. " },
  { value: "5.3.1.13", label: "5.3.1.13 Creación y puesta en marcha de la mesa de Comunicaciones. " },
]

  // Handle both array and string inputs
  let codesArray = []

  if (Array.isArray(indicadorCodes)) {
    codesArray = indicadorCodes
  } else if (typeof indicadorCodes === "string") {
    codesArray = indicadorCodes.split(",")
  } else {
    return ""
  }

  // Map each code to its description
  const descriptions = codesArray.map((code) => {
    const option = opcionesIndicadores.find((opt) => opt.value === code.trim())
    return option ? option.label : code
  })

  // Join the descriptions with line breaks
  return descriptions.join("<br>")
}

const getBPINDescriptions = (bpinCodes) => {
  if (!bpinCodes) return ""

  // Definir las opciones BPIN (copiar de ContractForm.jsx).
const opcionesBPIN = [
  { value: "", label: "Seleccionar..." },
  {
    value: "2018051290002",
    label: "2018051290002 Formación a las mujeres emprendedoras y empresarias para la paz y el progreso en el municipio de Caldas, Antioquia",
  },
  {
    value: "2018051290006",
    label: "2018051290006 Formulación del Plan Estratégico de Turismo en el municipio de Caldas, Antioquia",
  },
  {
    value: "2018051290008",
    label: "2018051290008 Elaboración y actualización de los instrumentos de control archivístico del municipio de Caldas, Antioquia",
  },
  {
    value: "2018051290005",
    label: "2018051290005 Construcción, mantenimiento y adecuación de Placas, centros deportivos y espacio público (Por compensaciones urbanísticas) en el municipio de Caldas, Antioquia",
  },
  {
    value: "2018051290003",
    label: "2018051290003 Construcción de obras de contención en la vía vereda sinifana en el municipio de Caldas, Antioquia",
  },
  {
    value: "2018051290007",
    label: "2018051290007 Fortalecimiento integral al funcionamiento de la Secretaría de Salud del Municipio de Caldas, Antioquia",
  },
]

  // Manejar tanto entradas de tipo arreglo como de tipo cadena.
  let codesArray = []

  if (Array.isArray(bpinCodes)) {
    codesArray = bpinCodes
  } else if (typeof bpinCodes === "string") {
    codesArray = bpinCodes.split(",")
  } else {
    return ""
  }

  // Asignar a cada código su descripción.
  const descriptions = codesArray.map((code) => {
    const option = opcionesBPIN.find((opt) => opt.value === code.trim())
    return option ? option.label : code
  })

  // Unir las descripciones con saltos de línea.
  return descriptions.join("<br>")
}

// Función para obtener descripciones de rubros
const getRubroDescriptions = (rubroCodes) => {
  if (!rubroCodes) return []

  // Definir opciones de rubros (esto debe coincidir con las opciones en ContractForm.jsx)
const opcionesRubros = {
 "231621128": {
    "nombreRubro": "Dotacion obreros",
    "rubro": "2.1.2.02.01.002.23.231621128.11001"
  },
  "1621129": {
  "nombreRubro": "Relaciones publicas",
  "rubro": "2.1.2.02.01.003.16.1621129.11001"
},
"231621129": {
    "nombreRubro": "Combustibles y lubricantes",
    "rubro": "2.1.2.02.01.003.23.231621129.11001"
  },
"231621130": {
    "nombreRubro": "Materiales y suministros",
    "rubro": "2.1.2.02.01.003.23.231621130.11001"
  },
"231621131": {
    "nombreRubro": "Comunicaciones y transporte",
    "rubro": "2.1.2.02.02.006.64119.23.231621131.11001"
  },
"231621132": {
    "nombreRubro": "Seguros y polizas",
    "rubro": "2.1.2.02.02.007.71359.23.231621132.11001"
  },
"161621104": {
    "nombreRubro": "Honorarios profesionales  - servicios personales indirectos",
    "rubro": "2.1.2.02.02.008.85999.16.161621104.11001"
  },
"231621134": {
    "nombreRubro": "Impresos y publicaciones",
    "rubro": "2.1.2.02.02.008.85999.23.231621134.11001"
  },
"231621135": {
    "nombreRubro": "Mantenimiento y reparaciones",
    "rubro": "2.1.2.02.02.008.85999.23.231621135.11001"
  },
"231621140": {
    "nombreRubro": "Salud ocupacional",
    "rubro": "2.1.3.07.02.031.23.231621140.11001"
  },
"111623901": {
    "nombreRubro": "2024052120024-AGR-321-11001",
    "rubro": "2.99.1702.11.111623901.11001"
  },
"111623902": {
    "nombreRubro": "2024052120024-AGR-322-11001",
    "rubro": "2.99.1702.11.111623902.11001"
  },
"222123920": {
    "nombreRubro": "2024052120063-SLD-114-11001",
    "rubro": "2.99.1903.19.02.92.22.222123920.11001"
  },
"222123921": {
    "nombreRubro": "2024052120063-SLD-114-23101",
    "rubro": "2.99.1903.19.02.93.22.222123921.23101"
  },
"222123901": {
    "nombreRubro": "2024052120063-SLD-114-11001",
    "rubro": "2.99.1903.19.05.44.22.222123901.11001"
  },
"222123902": {
    "nombreRubro": "2024052120063-SLD-114-23302",
    "rubro": "2.99.1903.19.05.44.22.222123902.23302"
  },
"222123914": {
    "nombreRubro": "2024052120063-SLD-113-11001",
    "rubro": "2.99.1903.22.222123914.11001"
  },
"222123915": {
    "nombreRubro": "2024052120063-SLD-114-11001",
    "rubro": "2.99.1903.22.222123915.11001"
  },
"222123919": {
    "nombreRubro": "202500000019875-SLD-112-23101",
    "rubro": "2.99.1905.19.02.103.22.222123919.23101"
  },
"222123918": {
    "nombreRubro": "202500000019875-SLD-112-11001",
    "rubro": "2.99.1905.19.02.99.22.222123918.11001"
  },
"181623901": {
    "nombreRubro": "2024052120050-INF-142-51001",
    "rubro": "2.99.2102.18.181623901.51001"
  },
"181623903": {
    "nombreRubro": "2024052120050-INF-262-11001",
    "rubro": "2.99.2102.18.181623903.11001"
  },
"181623904": {
    "nombreRubro": "2024052120052-INF-262-12002",
    "rubro": "2.99.2102.18.181623904.12002"
  },
"181623908": {
    "nombreRubro": "2024052120061-INF-212-14201",
    "rubro": "2.99.2102.18.181623908.14201"
  },
"181623909": {
    "nombreRubro": "2024052120061-INF-212-61001",
    "rubro": "2.99.2102.18.181623909.61001"
  },
"181623910": {
    "nombreRubro": "2024052120050-INF-221-51001",
    "rubro": "2.99.2102.18.181623910.51001"
  },
"181623911": {
    "nombreRubro": "2024052120050-INF-252-51001",
    "rubro": "2.99.2102.18.181623911.51001"
  },
"181623914": {
    "nombreRubro": "2024052120050-INF-262-51001",
    "rubro": "2.99.2102.18.181623914.51001"
  },
"181623915": {
    "nombreRubro": "2024052120050-INF-531-11001",
    "rubro": "2.99.2102.18.181623915.11001"
  },
"201623901": {
    "nombreRubro": "2024052120041-MOV-251-12003",
    "rubro": "2.99.2102.20.201623901.12003"
  },
"201623903": {
    "nombreRubro": "2024052120041-MOV-262-11001",
    "rubro": "2.99.2102.20.201623903.11001"
  },
"181623912": {
    "nombreRubro": "2024052120051-INF-252-11001",
    "rubro": "2.99.2402.18.181623912.11001"
  },
"181623913": {
    "nombreRubro": "2024052120051-INF-252-12003",
    "rubro": "2.99.2402.18.181623913.12003"
  },
"201623902": {
    "nombreRubro": "2024052120042-MOV-253-12003",
    "rubro": "2.99.2409.20.201623902.12003"
  },
"111623913": {
    "nombreRubro": "2024052120026-AGR-216-11001",
    "rubro": "2.99.3201.11.111623913.11001"
  },
"111623903": {
    "nombreRubro": "2024052120021-AGR-211-11001",
    "rubro": "2.99.3202.11.111623903.11001"
  },
"111623904": {
    "nombreRubro": "2024052120021-AGR-211-12007",
    "rubro": "2.99.3202.11.111623904.12007"
  },
"111623908": {
    "nombreRubro": "2024052120020-AGR-214-11001",
    "rubro": "2.99.3204.11.111623908.11001"
  },
"111623907": {
    "nombreRubro": "2024052120025-AGR-213-11001",
    "rubro": "2.99.3206.11.111623907.11001"
  },
"121623901": {
    "nombreRubro": "202500000021153-COM-132-11001",
    "rubro": "2.99.3301.12.121623901.11001"
  },
"121623902": {
    "nombreRubro": "202500000021153-COM-133-11001",
    "rubro": "2.99.3301.12.121623902.11001"
  },
"121623903": {
    "nombreRubro": "202500000021153-COM-134-11001",
    "rubro": "2.99.3301.12.121623903.11001"
  },
"141623901": {
    "nombreRubro": "202500000021153-EDU-134-11001",
    "rubro": "2.99.3301.14.141623901.11001"
  },
"141623902": {
    "nombreRubro": "202500000021153-EDU-134-14401",
    "rubro": "2.99.3301.14.141623902.14401"
  },
"141623903": {
    "nombreRubro": "202500000021153-EDU-134-14501",
    "rubro": "2.99.3301.14.141623903.14501"
  },
"141623911": {
    "nombreRubro": "202500000021153-EDU-131-11001",
    "rubro": "2.99.3301.14.141623911.11001"
  },
"141623912": {
    "nombreRubro": "202500000021153-EDU-131-13004",
    "rubro": "2.99.3301.14.141623912.13004"
  },
"141623913": {
    "nombreRubro": "202500000021153-EDU-132-11001",
    "rubro": "2.99.3301.14.141623913.11001"
  },
"141623914": {
    "nombreRubro": "202500000021153-EDU-132-14401",
    "rubro": "2.99.3301.14.141623914.14401"
  },
"141623916": {
    "nombreRubro": "202500000021153-EDU-133-11001",
    "rubro": "2.99.3301.14.141623916.11001"
  },
"141623917": {
    "nombreRubro": "202500000021153-EDU-133-13004",
    "rubro": "2.99.3301.14.141623917.13004"
  },
"141623918": {
    "nombreRubro": "202500000021153-EDU-133-14401",
    "rubro": "2.99.3301.14.141623918.14401"
  },
"131623906": {
    "nombreRubro": "2024052120037-DLL-333-11001",
    "rubro": "2.99.3502.13.131623906.11001"
  },
"131623915": {
    "nombreRubro": "2024052120037-DLL-332-14501",
    "rubro": "2.99.3502.13.131623915.14501"
  },
"131623901": {
    "nombreRubro": "2024052120030-DLL-311-11001",
    "rubro": "2.99.3602.13.131623901.11001"
  },
"131623902": {
    "nombreRubro": "2024052120030-DLL-314-11001",
    "rubro": "2.99.3602.13.131623902.11001"
  },
"131623903": {
    "nombreRubro": "2024052120030-DLL-314-14501",
    "rubro": "2.99.3602.13.131623903.14501"
  },
"131623904": {
    "nombreRubro": "2024052120030-DLL-315-11001",
    "rubro": "2.99.3602.13.131623904.11001"
  },
"131623905": {
    "nombreRubro": "2024052120030-DLL-315-14501",
    "rubro": "2.99.3602.13.131623905.14501"
  },
"131623907": {
    "nombreRubro": "2024052120030-DLL-341-11001",
    "rubro": "2.99.3602.13.131623907.11001"
  },
"131623908": {
    "nombreRubro": "2024052120030-DLL-342-11001",
    "rubro": "2.99.3602.13.131623908.11001"
  },
"131623909": {
    "nombreRubro": "2024052120030-DLL-343-11001",
    "rubro": "2.99.3602.13.131623909.11001"
  },
"131623910": {
    "nombreRubro": "2024052120030-DLL-344-11001",
    "rubro": "2.99.3602.13.131623910.11001"
  },
"131623912": {
    "nombreRubro": "2024052120030-DLL-311-14501",
    "rubro": "2.99.3602.13.131623912.14501"
  },
"131623913": {
    "nombreRubro": "2024052120030-DLL-312-14501",
    "rubro": "2.99.3602.13.131623913.14501"
  },
"131623914": {
    "nombreRubro": "2024052120030-DLL-313-14501",
    "rubro": "2.99.3602.13.131623914.14501"
  },
"191623908": {
    "nombreRubro": "2024052120054-ALC-241-11001",
    "rubro": "2.99.4001.19.191623908.11001"
  },
"211623901": {
    "nombreRubro": "2024052120072-PLA-232-11001",
    "rubro": "2.99.4002.21.211623901.11001"
  },
"211623902": {
    "nombreRubro": "2024052120072-PLA-261-11001",
    "rubro": "2.99.4002.21.211623902.11001"
  },
"111623905": {
    "nombreRubro": "2024052120018-AGR-212-11001",
    "rubro": "2.99.4003.11.111623905.11001"
  },
"111623906": {
    "nombreRubro": "2024052120018-AGR-212-31402",
    "rubro": "2.99.4003.11.111623906.31402"
  },
"111623909": {
    "nombreRubro": "2024052120022-AGR-215-11001",
    "rubro": "2.99.4003.11.111623909.11001"
  },
"111623910": {
    "nombreRubro": "2024052120022-AGR-215-14201",
    "rubro": "2.99.4003.11.111623910.14201"
  },
"111623911": {
    "nombreRubro": "2024052120022-AGR-215-21201",
    "rubro": "2.99.4003.11.111623911.21201"
  },
"111623912": {
    "nombreRubro": "2024052120022-AGR-215-31402",
    "rubro": "2.99.4003.11.111623912.31402"
  },
"181623905": {
    "nombreRubro": "2024052120048-INF-212-12011",
    "rubro": "2.99.4003.18.181623905.12011"
  },
"181623906": {
    "nombreRubro": "2024052120048-INF-212-14201",
    "rubro": "2.99.4003.18.181623906.14201"
  },
"181623907": {
    "nombreRubro": "2024052120048-INF-212-21201",
    "rubro": "2.99.4003.18.181623907.21201"
  },
"131623911": {
    "nombreRubro": "2024052120029-DLL-411-14501",
    "rubro": "2.99.4102.13.131623911.14501"
  },
"131623916": {
    "nombreRubro": "2024052120029-DLL-412-11001",
    "rubro": "2.99.4102.13.131623916.11001"
  },
"131623917": {
    "nombreRubro": "2024052120031-DLL-4101-14501",
    "rubro": "2.99.4102.13.131623917.14501"
  },
"131623918": {
    "nombreRubro": "2024052120029-DLL-421-11001",
    "rubro": "2.99.4102.13.131623918.11001"
  },
"131623919": {
    "nombreRubro": "2024052120029-DLL-421-14501",
    "rubro": "2.99.4102.13.131623919.14501"
  },
"131623921": {
    "nombreRubro": "2024052120034-DLL-441-11001",
    "rubro": "2.99.4102.13.131623921.11001"
  },
"131623922": {
    "nombreRubro": "2024052120034-DLL-441-14501",
    "rubro": "2.99.4102.13.131623922.14501"
  },
"151623905": {
    "nombreRubro": "2024052120038-GOB-4111-11001",
    "rubro": "2.99.4102.15.151623905.11001"
  },
"151623906": {
    "nombreRubro": "2024052120038-GOB-4111-12006",
    "rubro": "2.99.4102.15.151623906.12006"
  },
"151623907": {
    "nombreRubro": "2024052120038-GOB-4111-21401",
    "rubro": "2.99.4102.15.151623907.21401"
  },
"151623909": {
    "nombreRubro": "202500000024013-GOB-4111-21401",
    "rubro": "2.99.4102.15.151623909.21401"
  },
"151623910": {
    "nombreRubro": "2024052120038-GOB-4112-11001",
    "rubro": "2.99.4102.15.151623910.11001"
  },
"151623911": {
    "nombreRubro": "2024052120038-GOB-4113-21401",
    "rubro": "2.99.4102.15.151623911.21401"
  },
"181623902": {
    "nombreRubro": "2024052120038-INF-4111-51001",
    "rubro": "2.99.4102.18.181623902.51001"
  },
"222123911": {
    "nombreRubro": "2024052120065-SLD-121-11001",
    "rubro": "2.99.4102.22.222123911.11001"
  },
"222123912": {
    "nombreRubro": "2024052120065-SLD-121-14101",
    "rubro": "2.99.4102.22.222123912.14101"
  },
"222123913": {
    "nombreRubro": "2024052120065-SLD-121-31001",
    "rubro": "2.99.4102.22.222123913.31001"
  },
"131623920": {
    "nombreRubro": "2024052120033-DLL-421-14501",
    "rubro": "2.99.4103.13.131623920.14501"
  },
"131623923": {
    "nombreRubro": "2024052120033-DLL-451-11001",
    "rubro": "2.99.4103.13.131623923.11001"
  },
"131623924": {
    "nombreRubro": "2024052120033-DLL-451-14501",
    "rubro": "2.99.4103.13.131623924.14501"
  },
"131623925": {
    "nombreRubro": "2024052120033-DLL-461-11001",
    "rubro": "2.99.4103.13.131623925.11001"
  },
"131623926": {
    "nombreRubro": "2024052120033-DLL-461-14501",
    "rubro": "2.99.4103.13.131623926.14501"
  },
"141623904": {
    "nombreRubro": "202500000021180-EDU-134-11001",
    "rubro": "2.99.4104.14.141623904.11001"
  },
"141623905": {
    "nombreRubro": "202500000021180-EDU-121-11001",
    "rubro": "2.99.4104.14.141623905.11001"
  },
"141623906": {
    "nombreRubro": "202500000021180-EDU-121-14001",
    "rubro": "2.99.4104.14.141623906.14001"
  },
"141623907": {
    "nombreRubro": "202500000021180-EDU-122-11001",
    "rubro": "2.99.4104.14.141623907.11001"
  },
"141623908": {
    "nombreRubro": "202500000021180-EDU-122-14002",
    "rubro": "2.99.4104.14.141623908.14002"
  },
"141623909": {
    "nombreRubro": "202500000021180-EDU-122-14501",
    "rubro": "2.99.4104.14.141623909.14501"
  },
"141623910": {
    "nombreRubro": "202500000021180-EDU-123-11001",
    "rubro": "2.99.4104.14.141623910.11001"
  },
"141623915": {
    "nombreRubro": "202500000021180-EDU-132-11001",
    "rubro": "2.99.4104.14.141623915.11001"
  },
"141623919": {
    "nombreRubro": "202500000021180-EDU-133-11001",
    "rubro": "2.99.4104.14.141623919.11001"
  },
"222123916": {
    "nombreRubro": "2024052120064-SLD-431-11001",
    "rubro": "2.99.4104.22.222123916.11001"
  },
"222123917": {
    "nombreRubro": "2024052120064-SLD-431-13001",
    "rubro": "2.99.4104.22.222123917.13001"
  },
"231623901": {
    "nombreRubro": "202500000021180-SAD-121-11001",
    "rubro": "2.99.4104.23.231623901.11001"
  },
"231623902": {
    "nombreRubro": "202500000021180-SAD-122-11001",
    "rubro": "2.99.4104.23.231623902.11001"
  },
"231623903": {
    "nombreRubro": "202500000021180-SAD-132-11001",
    "rubro": "2.99.4104.23.231623903.11001"
  },
"151623901": {
    "nombreRubro": "2024052120068-GOB-141-11001",
    "rubro": "2.99.4301.15.151623901.11001"
  },
"171623901": {
    "nombreRubro": "2024052120068-ALC-141-11001",
    "rubro": "2.99.4301.17.171623901.11001"
  },
"171623902": {
    "nombreRubro": "2024052120068-ALC-141-13006",
    "rubro": "2.99.4301.17.171623902.13006"
  },
"171623903": {
    "nombreRubro": "2024052120068-ALC-141-14301",
    "rubro": "2.99.4301.17.171623903.14301"
  },
"171623904": {
    "nombreRubro": "2024052120068-ALC-141-14501",
    "rubro": "2.99.4301.17.171623904.14501"
  },
"171623905": {
    "nombreRubro": "2024052120074-ALC-142-11001",
    "rubro": "2.99.4301.17.171623905.11001"
  },
"171623906": {
    "nombreRubro": "2024052120075-ALC-143-11001",
    "rubro": "2.99.4301.17.171623906.11001"
  },
"171623907": {
    "nombreRubro": "2024052120075-ALC-143-61002",
    "rubro": "2.99.4301.17.171623907.61002"
  },
"111623914": {
    "nombreRubro": "2024052120019-AGR-221-11001",
    "rubro": "2.99.4501.11.111623914.11001"
  },
"131623927": {
    "nombreRubro": "2024052120036-DLL-471-14501",
    "rubro": "2.99.4502.13.131623927.14501"
  },
"131623928": {
    "nombreRubro": "2024052120035-DLL-481-14501",
    "rubro": "2.99.4502.13.131623928.14501"
  },
"131623929": {
    "nombreRubro": "2024052120069-DLL-491-11001",
    "rubro": "2.99.4502.13.131623929.11001"
  },
"131623930": {
    "nombreRubro": "2024052120069-DLL-491-14501",
    "rubro": "2.99.4502.13.131623930.14501"
  },
"131623931": {
    "nombreRubro": "2024052120032-DLL-521-14501",
    "rubro": "2.99.4502.13.131623931.14501"
  },
"151623902": {
    "nombreRubro": "2024052120055-GOB-231-11001",
    "rubro": "2.99.4503.15.151623902.11001"
  },
"151623903": {
    "nombreRubro": "2024052120055-GOB-231-11001",
    "rubro": "2.99.4503.15.151623903.11001"
  },
"151623904": {
    "nombreRubro": "2024052120055-GOB-233-21007",
    "rubro": "2.99.4503.15.151623904.21007"
  },
"151623908": {
    "nombreRubro": "2024052120055-GOB-4111-21401",
    "rubro": "2.99.4503.15.151623908.21401"
  },
"121623904": {
    "nombreRubro": "2024052120056-COM-531-11001",
    "rubro": "2.99.4599.12.121623904.11001"
  },
"121623905": {
    "nombreRubro": "2024052120056-COM-531-14501",
    "rubro": "2.99.4599.12.121623905.14501"
  },
"161623901": {
    "nombreRubro": "2024052120057-HAD-511-11001",
    "rubro": "2.99.4599.16.161623901.11001"
  },
"222123905": {
    "nombreRubro": "2024052120062-SLD-111-11001",
    "rubro": "2.99.4599.19.01.17.22.222123905.11001"
  },
"222123906": {
    "nombreRubro": "2024052120062-SLD-111-23001",
    "rubro": "2.99.4599.19.01.17.22.222123906.23001"
  },
"222123908": {
    "nombreRubro": "2024052120062-SLD-111-23004",
    "rubro": "2.99.4599.19.01.17.22.222123908.23004"
  },
"222123909": {
    "nombreRubro": "2024052120062-SLD-111-23005",
    "rubro": "2.99.4599.19.01.17.22.222123909.23005"
  },
"222123910": {
    "nombreRubro": "2024052120062-SLD-111-23006",
    "rubro": "2.99.4599.19.01.17.22.222123910.23006"
  },
"222123907": {
    "nombreRubro": "2024052120062-SLD-111-23003",
    "rubro": "2.99.4599.19.01.19.22.222123907.23003"
  },
"222123903": {
    "nombreRubro": "2024052120062-SLD-111-11001",
    "rubro": "2.99.4599.19.03.28.22.222123903.11001"
  },
"222123904": {
    "nombreRubro": "2024052120062-SLD-111-23202",
    "rubro": "2.99.4599.19.03.28.22.222123904.23202"
  },
"211623903": {
    "nombreRubro": "2024052120016-PLA-344-11001",
    "rubro": "2.99.4599.21.211623903.11001"
  },
"211623904": {
    "nombreRubro": "2024052120016-PLA-512-11001",
    "rubro": "2.99.4599.21.211623904.11001"
  },
"211623905": {
    "nombreRubro": "2024052120016-PLA-531-15001",
    "rubro": "2.99.4599.21.211623905.15001"
  },
"211623906": {
    "nombreRubro": "2024052120017-PLA-111-11001",
    "rubro": "2.99.4599.21.211623906.11001"
  },
"231623904": {
    "nombreRubro": "2024052120027-SAD-512-11001",
    "rubro": "2.99.4599.23.231623904.11001"
  },
"231623905": {
    "nombreRubro": "2024052120027-SAD-512-14501",
    "rubro": "2.99.4599.23.231623905.14501"
  },
"231623906": {
    "nombreRubro": "2024052120028-SAD-531-11001",
    "rubro": "2.99.4599.23.231623906.11001"
  },

"231623908": {
    "nombreRubro": "2024052120027-SAD-511-11001",
    "rubro": "2.99.4599.23.231623908.11001"
  },
"231623907": {
    "nombreRubro": " 2024052120028-SAD-531-14501",
    "rubro": "2.99.4599.23.231623907.14501"
  },
  "222121121": {
    "nombreRubro": " Honorarios Profesionales - Servicios Personales Indirectos",
    "rubro": "2.1.2.02.02.008.19.05.58.85999.22.222121121.23301"
  },
  "141623200": {
    "nombreRubro": " 202500000021180-EDU-123-11001",
    "rubro": "2.3.2.02.02.009.91119.16.141623200.11001"
  },
   "161621118": {
    "nombreRubro": " FONDO DE CONTINGENCIAS",
    "rubro": "2.2.2.04.16.161621118.11001"
  },
   "231621140": {
    "nombreRubro": "Salud Ocupacional",
    "rubro": "2.1.3.07.02.031.23.231621140.11001"
  },



};

  // Manejar tanto entradas de tipo arreglo como de tipo cadena
 
 let codesArray = [];
  if (Array.isArray(rubroCodes)) {
    codesArray = rubroCodes;
  } else if (typeof rubroCodes === "string") {
    codesArray = rubroCodes
      .split(",")
      .map((c) => c.trim())
      .filter(Boolean);
  } else {
    return [];
  }

  // Resolver cada código contra opcionesRubros
  return codesArray.map((code) => {
    const trimmed = String(code).trim();

    let option;

    if (Array.isArray(opcionesRubros)) {
      // cuando opcionesRubros es un ARRAY
      option = opcionesRubros.find(
        (opt) =>
          opt.codigo === trimmed ||
          opt.resumido === trimmed // por si usas otro campo
      );
    } else {
      // cuando opcionesRubros es un OBJETO tipo { "1621138": { ... } }
      option = opcionesRubros[trimmed];
    }

    if (!option) {
      // si no encuentra nada, al menos devuelve el código
      return { codigo: trimmed, nombre: "", rubro: "" };
    }

    // 👇 intentar sacar el nombre con varios posibles nombres de propiedad
    let nombre =
      option.nombre ??
      option.nombre_rubro ??
      option.nombreRubro ??
      option.nombre_rubro_presupuestal ??
      option.descripcion ??
      option.label ??
      "";

    // Si aún no hay nombre, tomar el primer string distinto de codigo/rubro
    if (!nombre) {
      const skipKeys = new Set(["codigo", "resumido", "rubro", "codigo_rubro"]);
      const firstTextKey = Object.keys(option).find(
        (k) => !skipKeys.has(k) && typeof option[k] === "string"
      );
      if (firstTextKey) {
        nombre = option[firstTextKey];
      }
    }

    // y el rubro completo igual
    const rubroCompleto = option.rubro ?? option.codigo_rubro ?? "";

    return {
      codigo: option.codigo || option.resumido || trimmed,
      nombre: nombre,
      rubro: rubroCompleto,
    };
  });
};



/**
 * Función para generar y descargar un PDF del formulario de contratos
 * @param {Object} contract - Datos del contrato
 * @param {string} filename - Nombre del archivo PDF a generar
 */
export const generateContractPDF = (contract, filename = "contrato.pdf") => {
  const formatDate = (dateString) => {
    if (!dateString) return ""
    const date = new Date(dateString)
    return date.toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" })
  }

  const element = document.createElement("div")
  element.className = "pdf-container"

  element.style.width = "210mm"
  element.style.fontSize = "10pt"
  element.style.lineHeight = "1.2"
  element.style.color = "#333"
  element.style.fontFamily = "Arial, sans-serif"
  element.style.backgroundColor = "white"
  element.style.padding = "5mm"

  const rubrosInfo = getRubroDescriptions(contract.discriminacionRubros)

  element.innerHTML = `
  <div style="background-color: rgb(244, 246, 252); padding: 10px; display: flex; align-items: center; justify-content: space-between; border-radius: 5px 5px 0 0;">
    <div style="display: flex; align-items: center;">
      <img src="${logo}" alt="Logo Alcaldía" style="height: 70px; margin-right: 10px;">
      <h1 style="margin: 0; font-size: 20px; font-weight: bold; color: black; text-align: center;">
        NECESIDADES DE CONTRATACIÓN
      </h1>
    </div>
    <div class="form-id" style="color: black; text-align: right;">
      <span style="display: block;">Código: A-CBS-F-021</span>
      <span style="display: block;">Versión: 07</span>
      <span style="display: block;">Fecha Actualización: 14-01-2025</span>
    </div>
  </div>

  <table style="width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 10pt;">
    <tr>
      <td style="padding: 5px; border: 1px solid #ddd; width: 25%;">
        <div style="font-weight: bold;">Fecha de solicitud</div>
        <div>${formatDate(contract.fechaSolicitud)}</div>
      </td>
      <td style="padding: 5px; border: 1px solid #ddd; width: 25%;">
        <div style="font-weight: bold;">Centro de Costos</div>
        <div>${contract.centroCostos || ""}</div>
      </td>
      <td style="padding: 5px; border: 1px solid #ddd; width: 25%;">
        <div style="font-weight: bold;">Secretaría</div>
        <div>${contract.secretaria || ""}</div>
      </td>
      <td style="padding: 5px; border: 1px solid #ddd; width: 25%;">
        <div style="font-weight: bold;">Número de Radicado</div>
        <div>${contract.radicado || "Sin radicado"}</div>
      </td>
    </tr>
  </table>

  <!-- 1. INFORMACIÓN JURÍDICA -->
  <div style="margin-top: 10px;">
    <h2 style="background-color: #f0f4f8; padding: 5px; margin: 10px 0 5px 0; border-left: 4px solid #1e40af; font-weight: 600; font-size: 12pt;">Información Jurídica</h2>
    <table style="width: 100%; border-collapse: collapse; font-size: 10pt;">
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd; width: 50%;">
          <div style="font-weight: bold;">Tipo de contrato</div>
          <div>${contract.tipoContrato || ""}</div>
        </td>
        <td style="padding: 5px; border: 1px solid #ddd; width: 50%;">
          <div style="font-weight: bold;">Modalidad de selección</div>
          <div>${contract.modalidadSeleccion || ""}</div>
        </td>
      </tr>
      <tr>
        <td colspan="2" style="padding: 5px; border: 1px solid #ddd;">
          <div style="font-weight: bold;">Objeto contractual</div>
          <div style="white-space: pre-wrap;">${contract.objetoContractual || ""}</div>
        </td>
      </tr>
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd;">
          <div style="font-weight: bold;">Duración (días)</div>
          <div><span style="font-weight: 600;">Fecha inicio:</span> ${formatDate(contract.fechaInicioContrato || contract.fecha_inicio_contrato || "")}</div>
          <div><span style="font-weight: 600;">Fecha fin:</span> ${formatDate(contract.fechaFinContrato || contract.fecha_fin_contrato || "")}</div>
          <div><span style="font-weight: 600;">Total:</span> ${(contract.duracionEstimada || contract.duracion_estimada) ? `${contract.duracionEstimada || contract.duracion_estimada} días` : ""}</div>
        </td>
        <td style="padding: 5px; border: 1px solid #ddd;">
          <div style="font-weight: bold;">Nombre Contratista</div>
          <div>${contract.nombreContratista || contract.nombre_contratista || ""}</div>
        </td>
      </tr>
    </table>
  </div>

  <!-- 2. INFORMACIÓN PRESUPUESTAL -->
  <div style="margin-top: 10px;">
    <h2 style="background-color: #f0f4f8; padding: 5px; margin: 10px 0 5px 0; border-left: 4px solid #1e40af; font-weight: 600; font-size: 12pt;">Información Presupuestal</h2>
    <table style="width: 100%; border-collapse: collapse; font-size: 10pt;">
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd; width: 50%;">
          <div style="font-weight: bold;">Naturaleza del gasto</div>
          <div style="white-space: pre-wrap;">${contract.naturalezaGasto || ""}</div>
        </td>
        <td style="padding: 5px; border: 1px solid #ddd; width: 50%;">
          <div style="font-weight: bold;">Presupuesto Total</div>
          <div>${contract.presupuestoTotal ? new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP" }).format(contract.presupuestoTotal) : ""}</div>
        </td>
      </tr>
    </table>
  </div>

  <!-- 3. PLAN DE DESARROLLO MUNICIPAL -->
  <div style="margin-top: 10px;">
    <h2 style="background-color: #f0f4f8; padding: 5px; margin: 10px 0 5px 0; border-left: 4px solid #1e40af; font-weight: 600; font-size: 12pt;">Información Plan de Desarrollo Municipal</h2>
    <table style="width: 100%; border-collapse: collapse; font-size: 10pt;">
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd; vertical-align: top;">
          <div style="font-weight: bold;">Programa</div>
          <div>${getProgramaDescriptions(contract.programa)}</div>
        </td>
      </tr>
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd; vertical-align: top;">
          <div style="font-weight: bold;">Indicador</div>
          <div>${getIndicadorDescriptions(contract.indicador)}</div>
        </td>
      </tr>
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd; vertical-align: top;">
          <div style="font-weight: bold;">BPIN</div>
          <div>${getBPINDescriptions(contract.bpin)}</div>
        </td>
      </tr>
    </table>
  </div>

  <!-- 4. DISCRIMINACIÓN DE RUBROS -->
  <div style="margin-top: 10px;">
    <h2 style="background-color: #f0f4f8; padding: 5px; margin: 10px 0 5px 0; border-left: 4px solid #1e40af; font-weight: 600; font-size: 12pt;">Discriminación de Rubros presupuestales</h2>
    <table style="width: 100%; border-collapse: collapse; font-size: 10pt;">
      <thead>
        <tr style="background-color: #f9fafb;">
          <th style="padding: 5px; border: 1px solid #ddd; text-align: left;">Resumido</th>
          <th style="padding: 5px; border: 1px solid #ddd; text-align: left;">Rubro</th>
          <th style="padding: 5px; border: 1px solid #ddd; text-align: left;">Nombre rubro</th>
          <th style="padding: 5px; border: 1px solid #ddd; text-align: left;">Valor</th>
        </tr>
      </thead>
      <tbody>
        ${rubrosInfo.length > 0
          ? rubrosInfo.map((rubro, index) => {
              const valores = Array.isArray(contract.valores)
                ? contract.valores
                : typeof contract.valores === "string" && contract.valores
                ? contract.valores.split("||")
                : Array.isArray(contract.valor)
                ? contract.valor
                : typeof contract.valor === "string" && contract.valor
                ? contract.valor.split("||")
                : [];
              return `
                <tr>
                  <td style="padding: 5px; border: 1px solid #ddd;">${rubro.codigo || ""}</td>
                  <td style="padding: 5px; border: 1px solid #ddd;">${rubro.rubro || ""}</td>
                  <td style="padding: 5px; border: 1px solid #ddd;">${rubro.nombre || ""}</td>
                  <td style="padding: 5px; border: 1px solid #ddd;">${valores[index] || ""}</td>
                </tr>
              `;
            }).join("")
          : '<tr><td colspan="4" style="padding: 5px; border: 1px solid #ddd; text-align: center;">No hay rubros seleccionados</td></tr>'
        }
      </tbody>
    </table>
    <table style="width: 100%; border-collapse: collapse; margin-top: 5px; font-size: 10pt;">
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd;">
          <div style="font-weight: bold;">Forma de pago</div>
          <div>${contract.formaPago === "unico_pago" ? "Único Pago" : contract.formaPago === "mensual" ? "Mensual" : contract.formaPago || ""}</div>
        </td>
      </tr>
    </table>
  </div>

  <!-- 5. PRESUPUESTO ASOCIADO AL INDICADOR -->
  ${(() => {
    let indPres = [];
    try {
      const raw = contract.indicador_presupuesto;
      indPres = raw ? (typeof raw === "string" ? JSON.parse(raw) : raw) : [];
    } catch(e) { indPres = []; }

    if (!indPres || indPres.length === 0) return "";

    const totalPct = indPres.reduce((s, r) => s + (parseFloat(r.porcentaje) || 0), 0);
    const totalVal = indPres.reduce((s, r) => s + (parseFloat(r.total) || 0), 0);

    return `
    <div style="margin-top: 10px;">
      <h2 style="background-color: #f0f4f8; padding: 5px; margin: 10px 0 5px 0; border-left: 4px solid #1e40af; font-weight: 600; font-size: 12pt;">Presupuesto asociado al indicador</h2>
      <table style="width: 100%; border-collapse: collapse; font-size: 10pt;">
        <thead>
          <tr style="background-color: #f9fafb;">
            <th style="padding: 5px; border: 1px solid #ddd; text-align: left;">Indicador</th>
            <th style="padding: 5px; border: 1px solid #ddd; text-align: left;">Porcentaje (%)</th>
            <th style="padding: 5px; border: 1px solid #ddd; text-align: left;">Total ($)</th>
          </tr>
        </thead>
        <tbody>
          ${indPres.map(row => `
            <tr>
              <td style="padding: 5px; border: 1px solid #ddd;">${row.codigo || row.indicador || ""}</td>
              <td style="padding: 5px; border: 1px solid #ddd;">${row.porcentaje || ""}%</td>
              <td style="padding: 5px; border: 1px solid #ddd;">${new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP" }).format(row.total || 0)}</td>
            </tr>
          `).join("")}
          <tr style="font-weight: bold; background-color: #f9fafb;">
            <td style="padding: 5px; border: 1px solid #ddd;">Total</td>
            <td style="padding: 5px; border: 1px solid #ddd;">${totalPct.toFixed(2)}%</td>
            <td style="padding: 5px; border: 1px solid #ddd;">${new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP" }).format(totalVal)}</td>
          </tr>
        </tbody>
      </table>
    </div>
    `;
  })()}

  <!-- 6. DATOS DEL SOLICITANTE -->
  <div style="margin-top: 10px;">
    <h2 style="background-color: #f0f4f8; padding: 5px; margin: 10px 0 5px 0; border-left: 4px solid #1e40af; font-weight: 600; font-size: 12pt;">Datos del Solicitante</h2>
    <table style="width: 100%; border-collapse: collapse; font-size: 10pt;">
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd; width: 33%;">
          <div style="font-weight: bold;">Nombre</div>
          <div>${contract.nombreSolicitante || ""}</div>
        </td>
        <td style="padding: 5px; border: 1px solid #ddd; width: 33%;">
          <div style="font-weight: bold;">Cargo</div>
          <div>${contract.cargoSolicitante || ""}</div>
        </td>
        <td style="padding: 5px; border: 1px solid #ddd; width: 33%;">
          <div style="font-weight: bold;">Firma</div>
          <div>${contract.firma_solicitante_url ? `<img src="${contract.firma_solicitante_url}" alt="Firma del solicitante" style="max-height: 40px; max-width: 100%;">` : ""}</div>
        </td>
      </tr>
    </table>
  </div>

  <!-- 7. APROBACIONES -->
  <div style="margin-top: 10px;">
    <h2 style="background-color: #f0f4f8; padding: 5px; margin: 10px 0 5px 0; border-left: 4px solid #1e40af; font-weight: 600; font-size: 12pt;">Aprobaciones</h2>
    <table style="width: 100%; border-collapse: collapse; font-size: 10pt;">
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd; width: 50%;">
          <div style="font-weight: bold;">Departamento Administrativo</div>
          <div>${contract.aprobacion_administrativa === "aprobado" ? "Aprobado" : contract.aprobacion_administrativa === "rechazado" ? "Rechazado" : ""}</div>
        </td>
        <td style="padding: 5px; border: 1px solid #ddd; width: 50%;">
          <div style="font-weight: bold;">Firma</div>
          <div>${contract.firma_administrativa_url ? `<img src="${contract.firma_administrativa_url}" alt="Firma administrativa" style="max-height: 40px; max-width: 100%;">` : ""}</div>
        </td>
      </tr>
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd;">
          <div style="font-weight: bold;">Secretaría de Hacienda</div>
          <div>${contract.aprobacion_hacienda === "aprobado" ? "Aprobado" : contract.aprobacion_hacienda === "rechazado" ? "Rechazado" : ""}</div>
        </td>
        <td style="padding: 5px; border: 1px solid #ddd;">
          <div style="font-weight: bold;">Firma</div>
          <div>${contract.firma_hacienda_url ? `<img src="${contract.firma_hacienda_url}" alt="Firma de hacienda" style="max-height: 40px; max-width: 100%;">` : ""}</div>
        </td>
      </tr>
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd;">
          <div style="font-weight: bold;">Alcalde Municipal</div>
          <div>${contract.aprobacion_alcalde === "aprobado" ? "Aprobado" : contract.aprobacion_alcalde === "rechazado" ? "Rechazado" : ""}</div>
        </td>
        <td style="padding: 5px; border: 1px solid #ddd;">
          <div style="font-weight: bold;">Firma</div>
          <div>${contract.firma_alcalde_url ? `<img src="${contract.firma_alcalde_url}" alt="Firma del alcalde" style="max-height: 40px; max-width: 100%;">` : ""}</div>
        </td>
      </tr>
    </table>
  </div>

  <!-- 8. COMITÉ DE CONTRATACIÓN -->
  <div style="margin-top: 10px;">
    <h2 style="background-color: #f0f4f8; padding: 5px; margin: 10px 0 5px 0; border-left: 4px solid #1e40af; font-weight: 600; font-size: 12pt;">Información del Comité de Contratación</h2>
    <table style="width: 100%; border-collapse: collapse; font-size: 10pt;">
      <tr>
        <td style="padding: 5px; border: 1px solid #ddd; width: 50%;">
          <div style="font-weight: bold;">Número de Acta</div>
          <div>${contract.numeroActa || ""}</div>
        </td>
        <td style="padding: 5px; border: 1px solid #ddd; width: 50%;">
          <div style="font-weight: bold;">Fecha del Comité</div>
          <div>${formatDate(contract.fechaComite)}</div>
        </td>
      </tr>
    </table>
  </div>

  <!-- 9. OBSERVACIONES -->
  <div style="margin-top: 10px;">
    <h2 style="background-color: #f0f4f8; padding: 5px; margin: 10px 0 5px 0; border-left: 4px solid #1e40af; font-weight: 600; font-size: 12pt;">Observaciones</h2>
    <div style="border: 1px solid #ddd; border-radius: 5px; padding: 5px; min-height: 40px; font-size: 10pt;">
      ${contract.observaciones || ""}
    </div>
  </div>

  <div style="margin-top: 10px; text-align: center; padding: 5px; background-color: #f3f4f6; border-top: 1px solid #e5e7eb; font-size: 10px; color: #6b7280;">
    <p style="margin: 0;">Página 1 de 1 • Oficina Jurídica</p>
  </div>
`

  // ✅ WATERMARK — aplicar ANTES de convertir a PDF
  if (contract.status === "anulado") {
    const svgWatermark = encodeURIComponent(`
      <svg xmlns='http://www.w3.org/2000/svg' width='600' height='400'>
        <text
          x='50%' y='55%'
          font-size='110'
          font-weight='900'
          font-family='Arial Black, sans-serif'
          fill='rgba(220,38,38,0.13)'
          text-anchor='middle'
          dominant-baseline='middle'
          letter-spacing='12'
          transform='rotate(-45 300 200)'
        >ANULADO</text>
      </svg>
    `)
    element.style.backgroundImage = `url("data:image/svg+xml,${svgWatermark}")`
    element.style.backgroundRepeat = "repeat"
    element.style.backgroundSize = "400px 400px"
  }

  // Añadir temporalmente al DOM para mejor renderizado
  document.body.appendChild(element)

  const options = {
    margin: [5, 5, 5, 5],
    filename: filename,
    image: { type: "jpeg", quality: 0.95 },
    html2canvas: {
      scale: 1,
      useCORS: true,
      letterRendering: true,
      allowTaint: true,
      scrollX: 0,
      scrollY: 0,
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait",
      compress: true,
    },
    pagebreak: { mode: ["avoid-all"] },
  }

  return html2pdf()
    .from(element)
    .set(options)
    .toPdf()
    .get("pdf")
    .then((pdf) => {
      pdf.setProperties({
        title: "Necesidades de Contratación",
        subject: "Formulario de Necesidades de Contratación",
        creator: "Sistema de Contratación",
        author: "Alcaldía de Copacabana",
      })
      pdf.save(filename)
      if (document.body.contains(element)) {
        document.body.removeChild(element)
      }
    })
    .catch((error) => {
      console.error("Error al generar el PDF:", error)
      if (document.body.contains(element)) {
        document.body.removeChild(element)
      }
    })
}